import { InlineMenu } from "./components/InlineMenu";
import { CiteMenu } from "./components/CiteMenu";
import { useState, useRef } from "react";
import "@blocknote/core/style.css";
import "./NotesMaker.css";
import "../SummaryGenerator/NotesMaker.css";
import axios from "axios";
import useContextMenu from "./useContextMenu";
import FolderIcon from "@mui/icons-material/Folder";
// import InsertDriveFileTwoToneIcon from "@mui/icons-material/InsertDriveFileOutlined";
// import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import { styled, alpha } from "@mui/material/styles";

import {
  Alert,
  BottomNavigation,
  BottomNavigationAction,
  MenuItem,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Drawer,
  FormControl,
  IconButton,
  InputLabel,
  ListItem,
  Select,
  // Skeleton,
  Snackbar,
  Switch,
  TextField,
  Tooltip,
  Typography,
  Menu,
  Divider,
} from "@mui/material";
import {
  Bolt,
  // Book,
  FilterAlt,
  LastPage,
  // Note,
  Print,
  Save,
  Science,
  Search,
  // Subject,
  Timer,
  // Chat,
  Refresh,
  Share,
  Stop,
  TravelExplore,
  AutoFixHigh,
  // ResetTvSharp,
  // ScienceOutlined,
  MoreVert,
} from "@mui/icons-material";
// import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
// import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import "../books_landing/animation.css";
// import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { useTranslation } from "react-i18next";
// import Summarize from "@mui/icons-material/Summarize";
import { useEffect, useCallback } from "react";
import React from "react";
import PropTypes from "prop-types";
// import { database } from "../../Firebase";
// import { child, get, onValue, ref, set } from "firebase/database";
import { gapi } from "gapi-script";
// import Drivelogo1 from "./components/Drivelogo";
// import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
// import CircleRoundedIcon from "@mui/icons-material/CircleRounded";
import Loading from "../books_landing/Loading";
import { Fade } from "react-reveal";
import EditorJS from "@editorjs/editorjs";
import Header from "@editorjs/header";
import List from "@editorjs/list";
// import Embed from "@editorjs/embed";
import SimpleImage from "@editorjs/simple-image";
import Checklist from "@editorjs/checklist";
// import Quote from "@editorjs/quote";
import Marker from "@editorjs/marker";
import Table from "@editorjs/table";
import Warning from "@editorjs/warning";
import Delimiter from "@editorjs/delimiter";
import InlineCode from "@editorjs/inline-code";
import Underline from "@editorjs/underline";
import CodeTool from "@editorjs/code";
import Undo from "editorjs-undo";
// import createGenericInlineTool from "editorjs-inline-tool";
import ResearchCard from "./ResearchCard";
import { InlineResearchButton } from "./components/InlineResearchButton";
import { InlineCiteButton } from "./components/InlineCiteButton";
import WIkiCard from "./WIkiCard";
// import MoreVertIcon from "@mui/icons-material/MoreVert";
// import { useTheme } from "@mui/material/styles";
// import { event } from "react-ga";

const ColorPlugin = require("editorjs-text-color-plugin");
const Hyperlink = require("editorjs-hyperlink");
// Context Menu Styling -->
const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

export default function NotesMaker({
  sendRefToParent,
  LeftDrawerOpen,
  setSnackbarText,
  snackbarText,
  caption,
  headCaption,
  titleObject,
  notes,
  newNotesTitle,
  category,
  setNotesName,
  setSavedNotes,
  request,
  fetchNotes,
  sideMenu,
  setSideMenu,
  setText,
  editTitle,
  text,
  notesId,
  re2,
  setre2,
  sty,
  setsty,
  sar,
  setsar,
  gs,
  setgs,
  re,
  setre,
  parad,
  setparad,
  dri,
  setdri,
  handleTimerStart,
  handleTimerStop,
  timerStart,
  convertStoMs,
  time,
  timerd,
  settimerd,
  setcompletiond,
  completiond,
  Notesuuid,
  shareDialog,
  sav,
  setsav,
}) {
  const [open, setOpen] = useState(false);
  const [selectedText, setSelectedText] = useState("");
  const [score, setScore] = useState(0);
  const [language, setLanguage] = useState("en");
  const [inlineLanguage, setInlineLanguage] = useState("");
  const [tone, setTone] = useState("Professional");
  const [style, setStyle] = useState("Poetic");
  const [syncing, setSyncing] = useState(false);
  const { clicked, setClicked, points, setPoints } = useContextMenu();
  const [SummeriseText, setSummeriseText] = useState();
  const [ElaborateText, setElaborateText] = useState();
  const [researchText, setResearchText] = useState("");
  const [researchResponse, setResearchResponse] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  // const [isActive, setIsActive] = useState(false);
  const [generateDialog, setGenerateDialog] = useState(false);
  const [inlineMenu, setInlineMenu] = useState(true);
  const [citeMenu, setCiteMenu] = useState(false);
  const [generateDialog1, setGenerateDialog1] = useState(false);
  const [generateInput, setGenerateInput] = useState("");
  const [aiText, setAiText] = useState("");
  const [sources, setSources] = useState([]);
  const [tab, setTab] = useState(2);
  // const [more, setMore] = useState(2);
  // const [initNotes, setInitNotes] = useState();
  const [listDocumentsVisible, setListDocumentsVisibility] = useState(false);
  const [documents, setDocuments] = useState([]);
  const [isLoadingGoogleDriveApi, setIsLoadingGoogleDriveApi] = useState(false);
  const [isFetchingGoogleDriveFiles, setIsFetchingGoogleDriveFiles] =
    useState(false);
  const [signedInUser, setSignedInUser] = useState();
  const [listvisible, setlistvisible] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [showsearch, setshowsearch] = useState(false);
  const [foldersdata, setfoldersdata] = useState();
  const [length1, setlength1] = useState(0);
  const [ai1, setai1] = useState("false");
  const [show1, setshow1] = useState(false);
  // const [su, setsu] = useState("false");
  const [el, setel] = useState("false");
  // const [gendone, setgendone] = useState("false");
  const [ft, setft] = useState("false");
  const [filename1, setfilename1] = useState("");
  const [showchatwithpdf, setshowchatwithpdf] = useState(false);
  const [showfolder, setshowfolder] = useState(false);
  const [localfile, setlocalfile] = useState();
  let navigate = useNavigate();
  const [displayMessages, setdisplayMessages] = useState([]);
  const [showprogressbar, setshowprogressbar] = useState();
  const [academic, setAcademic] = useState(true);
  const [offset, setOffset] = useState(10);
  const [showLoadMore, setShowLoadMore] = useState(false);
  // const [selectedOption, setSelectedOption] = useState("paraphrase");
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorEl2, setAnchorEl2] = useState(null);
  const [anchorEl3, setAnchorEl3] = useState(null);
  const [anchorEl4, setAnchorEl4] = useState(null);
  // const theme = useTheme();
  const [contextMenuOption, setContextMenuOption] = useState("");
  const [contextSubMenuPrimaryOption, setContextSubMenuPrimaryOption] =
    useState("null");
  const [contextSubMenuSecondaryOption, setContextSubMenuSecondaryOption] =
    useState("null");
  const [isBookmarked, setisBookmarked] = useState(false);
  const [mobileDrawer, setMobileDrawer] = useState(
    window.innerWidth <= 1024 ? true : false
  );
  const [isOptionsVisible, setIsOptionsVisible] = useState(true);
  const [glowUp, setGlowUp] = useState(false);
  const [inlineResult, setInlineResult] = useState([]);
  const [showInlineResult, setShowInlineResult] = useState();
  const openMainMenu = Boolean(anchorEl);
  const openSubMenuParaphrase = Boolean(anchorEl2);
  const openSubMenuSimplify = Boolean(anchorEl3);
  const openSubMenuTranslate = Boolean(anchorEl4);
  const [citations, setCitations] = useState([]);
  useEffect(() => {
    const handleResize = () => {
      setMobileDrawer(window.innerWidth <= 1024);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const handleAnchorClick = (event) => {
      const ceParagraphDiv = event.target.closest(".ce-paragraph a");

      if (ceParagraphDiv) {
        const ceParagraphParent = ceParagraphDiv.closest(".ce-paragraph");
        ceParagraphParent.setAttribute("contenteditable", "false");
        ceParagraphDiv.setAttribute("target", "_blank");
      }
    };
    document.body.addEventListener("click", handleAnchorClick);
    return () => {
      document.body.removeEventListener("click", handleAnchorClick);
    };
  }, []);

  const FormData = require("form-data");
  // const fs = require("fs");

  const onSetPropSources = (value) => {
    setSources(value);
  };
  const setPropGenerateInput = (value) => {
    setGenerateInput(value);
  };

  const bottomRef = useRef(null);
  useEffect(() => {
    let msgs = JSON.parse(localStorage.getItem("chats"));
    if (msgs !== null) setdisplayMessages(msgs);
  }, []);

  const [msg, setMsg] = useState("");
  const [input, setInput] = useState(false);
  const ref = useRef();

  const getIndex = (category, title, titleData) => {
    const titlesArray = titleData[category];
    if (titlesArray !== undefined) {
      const index = titlesArray.indexOf(title);
      return index;
    }
  };
  // this was to implement selection in mobile with touching
  useEffect(() => {
    let touchTimer;

    const handleSelectionChange = () => {
      const selection = window.getSelection();
      if (selection && selection.toString().trim() !== "") {
        const newSelection = selection.toString().trim();
        if (newSelection !== generateInput) {
          setGenerateInput(newSelection);
          setInlineResult(newSelection);
        }
      }
    };
    const handleTouchStart = () => {
      touchTimer = setTimeout(() => {
        handleSelectionChange();
      }, 500);
    };
    const handleTouchEnd = () => {
      clearTimeout(touchTimer);
    };
    document.addEventListener("selectionchange", handleSelectionChange);
    document.addEventListener("touchstart", handleTouchStart);
    document.addEventListener("touchend", handleTouchEnd);
    return () => {
      document.removeEventListener("selectionchange", handleSelectionChange);
      document.removeEventListener("touchstart", handleTouchStart);
      document.removeEventListener("touchend", handleTouchEnd);
    };
  }, [generateInput]);

  let notesLength = null;
  if (notes == null) notesLength = 0;

  notesLength =
    notes[headCaption][getIndex(headCaption, caption, titleObject)].notes
      .length;

  sendRefToParent(ref);
  useEffect(() => {
    const config = {
      shortcuts: {
        undo: "Ctrl+X",
        redo: "Ctrl+Y",
      },
    };
    if (!ref.current) {
      const editor = new EditorJS({
        onReady: () => {
          ref.current = editor;
          const undo = new Undo({ editor, config });
        },
        holder: "editorjs",
        inlineToolbar: [
          "research",
          "cite",
          "bold",
          "italic",
          "underline",
          "inlineCode",
          "Color",
          "marker",
        ],
        tools: {
          research: {
            class: InlineResearchButton,
            config: {
              buttonHTML: `
                  <div class="!text-[0.8rem] hover:text-blue-200 text-xs leading-5 font-medium flex items-center gap-1 text-primary-700 hover:text-primary-800">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.64742 10.3326C8.94392 11.0736 8.9743 12.2445 9.71526 12.948L18.2727 21.0727C19.0136 21.7762 20.1846 21.7458 20.8881 21.0049C21.5916 20.2639 21.5612 19.093 20.8202 18.3895L12.2628 10.2648C11.5219 9.56122 10.3509 9.5916 9.64742 10.3326ZM10.7481 11.8602C10.6079 11.7271 10.6021 11.5056 10.7352 11.3654C10.8683 11.2252 11.0899 11.2195 11.23 11.3526L14.3049 14.272L13.823 14.7796L10.7481 11.8602Z" fill="currentColor"></path><path d="M15.7103 2.07601C15.79 1.78 16.21 1.78 16.2897 2.07601L17.0158 4.77267C17.0436 4.87591 17.1242 4.95656 17.2274 4.98436L19.9241 5.71043C20.2201 5.79013 20.2201 6.21009 19.9241 6.28979L17.2274 7.01586C17.1242 7.04366 17.0436 7.12431 17.0158 7.22755L16.2897 9.92421C16.21 10.2202 15.79 10.2202 15.7103 9.92421L14.9842 7.22755C14.9564 7.12431 14.8758 7.04366 14.7726 7.01586L12.0759 6.28979C11.7799 6.21009 11.7799 5.79013 12.0759 5.71043L14.7726 4.98436C14.8758 4.95656 14.9564 4.87591 14.9842 4.77267L15.7103 2.07601Z" fill="currentColor"></path><path d="M5.16534 3.72291C5.21889 3.524 5.50111 3.524 5.55467 3.72291L6.04259 5.53507C6.06127 5.60445 6.11547 5.65864 6.18485 5.67732L7.997 6.16524C8.19592 6.2188 8.19592 6.50102 7.997 6.55458L6.18485 7.0425C6.11547 7.06118 6.06127 7.11537 6.04259 7.18475L5.55467 8.99691C5.50111 9.19582 5.21889 9.19582 5.16534 8.99691L4.67742 7.18475C4.65874 7.11537 4.60454 7.06118 4.53516 7.0425L2.723 6.55458C2.52409 6.50102 2.52409 6.2188 2.723 6.16524L4.53516 5.67732C4.60454 5.65864 4.65874 5.60445 4.67742 5.53507L5.16534 3.72291Z" fill="currentColor"></path><path d="M5.95667 13.9038C6.02361 13.6551 6.37639 13.6551 6.44333 13.9038L7.05323 16.1689C7.07658 16.2557 7.14433 16.3234 7.23105 16.3468L9.49624 16.9567C9.74489 17.0236 9.74489 17.3764 9.49625 17.4433L7.23105 18.0532C7.14433 18.0766 7.07658 18.1443 7.05323 18.2311L6.44333 20.4962C6.37639 20.7449 6.02361 20.7449 5.95667 20.4962L5.34677 18.2311C5.32342 18.1443 5.25567 18.0766 5.16895 18.0532L2.90375 17.4433C2.65511 17.3764 2.65511 17.0236 2.90375 16.9567L5.16895 16.3468C5.25567 16.3234 5.32342 16.2557 5.34677 16.1689L5.95667 13.9038Z" fill="currentColor"></path></svg>
                  <p class="m-auto">AI Commands</p> 
                  </div>
              `,
              html: "<b>template</b>⭐",
              setResearchDialog: setGenerateDialog,
              setInlineResult: setInlineResult,
              setGlowUp: setGlowUp,
              setGenerateDialog: setGenerateDialog,
              setInlineMenu: setInlineMenu,
            },
          },
          cite: {
            class: InlineCiteButton,
            config: {
              buttonHTML: `
              <div class="!text-[0.8rem] hover:text-blue-200 text-xs leading-5 font-medium flex items-center gap-1 text-primary-700 hover:text-primary-800">
                <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_450_4531)"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.3952 0.0803087C13.424 -0.0267696 13.576 -0.0267696 13.6048 0.0803087L13.8675 1.05592C13.8776 1.09327 13.9067 1.12245 13.9441 1.13252L14.9196 1.39519C15.0268 1.42403 15.0268 1.57596 14.9196 1.6048L13.9441 1.86749C13.9067 1.87754 13.8776 1.90672 13.8675 1.94407L13.6048 2.91968C13.576 3.02677 13.424 3.02677 13.3952 2.91968L13.1326 1.94407C13.1225 1.90672 13.0933 1.87754 13.056 1.86749L12.0802 1.6048C11.9733 1.57596 11.9733 1.42403 12.0802 1.39519L13.056 1.13252C13.0933 1.12245 13.1225 1.09327 13.1326 1.05592L13.3952 0.0803087ZM18.0627 1.13644C18.1117 0.954521 18.3698 0.954521 18.4188 1.13644L18.7998 2.55162C18.8169 2.61507 18.8665 2.66462 18.9299 2.68171L20.3451 3.06274C20.527 3.11173 20.527 3.36982 20.3451 3.4188L18.9299 3.79984C18.8665 3.81693 18.8169 3.86648 18.7998 3.92993L18.4188 5.34511C18.3698 5.52703 18.1117 5.52703 18.0627 5.34511L17.6817 3.92993C17.6646 3.86648 17.615 3.81693 17.5516 3.79984L16.1364 3.4188C15.9545 3.36982 15.9545 3.11173 16.1364 3.06274L17.5516 2.68171C17.615 2.66462 17.6646 2.61507 17.6817 2.55162L18.0627 1.13644ZM5.72631 5C7.13024 5 8.43945 5.3989 9.54041 6.08648V17.5C8.50389 16.6647 7.17568 16.1634 5.72631 16.1634C5.02482 16.1634 4.35259 16.2808 3.7284 16.496C3.56164 16.5535 3.37664 16.5285 3.23222 16.4288C3.08781 16.3292 3.00195 16.1674 3.00195 15.9948V5.89457C3.00195 5.66928 3.14752 5.46845 3.36525 5.39337C4.10445 5.13847 4.8994 5 5.72631 5ZM14.4443 16.1634C12.9949 16.1634 11.6667 16.6647 10.6302 17.5V6.08648C11.7311 5.3989 13.0403 5 14.4443 5C15.2712 5 16.0661 5.13847 16.8053 5.39337C17.0231 5.46845 17.1686 5.66928 17.1686 5.89457V15.9948C17.1686 16.1674 17.0828 16.3292 16.9384 16.4288C16.7939 16.5285 16.6089 16.5535 16.4422 16.496C15.818 16.2808 15.1458 16.1634 14.4443 16.1634Z" fill="currentColor"></path></g><defs><clipPath id="clip0_450_4531"><rect width="20" height="20" fill="white" transform="translate(0.5)"></rect></clipPath></defs></svg>
               <p class="m-auto">Cite</p>
              </div>
              `,
              html: "<b>template</b>⭐",
              setResearchDialog: setGenerateDialog,
              setGenerateInput: setGenerateInput,
              setGlowUp: setGlowUp,
              setGenerateDialog: setGenerateDialog,
              setCiteMenu: setCiteMenu,
            },
          },
          header: {
            class: Header,
            inlineToolbar: true,
            config: {
              placeholder: "Enter a header",
              levels: [2, 3, 4],
              defaultLevel: 2,
            },
            shortcut: "CMD+SHIFT+H",
          },

          underline: Underline,
          image: {
            class: SimpleImage,
            inlineToolbar: ["link"],
          },
          list: {
            class: List,
            inlineToolbar: true,
            shortcut: "CMD+SHIFT+L",
            config: {
              dafaultStyle: "unordered",
            },
          },
          checklist: {
            class: Checklist,
            inlineToolbar: true,
          },
          table: {
            class: Table,
            inlineToolbar: true,
            config: {
              rows: 2,
              cols: 3,
            },
          },
          delimiter: Delimiter,
          inlineCode: {
            class: InlineCode,
            shortcut: "CMD+SHIFT+C",
          },
          code: {
            class: CodeTool,
            shortcut: "CMD+SHIFT+C",
          },
          warning: Warning,
          Color: {
            class: ColorPlugin,
            config: {
              colorCollections: [
                "#EC7878",
                "#9C27B0",
                "#673AB7",
                "#3F51B5",
                "#0070FF",
                "#03A9F4",
                "#00BCD4",
                "#4CAF50",
                "#8BC34A",
                "#CDDC39",
                "#FFF",
              ],
              defaultColor: "#FF1300",
              type: "text",
              customPicker: true,
            },
          },
          marker: {
            class: Marker,
            config: {
              defaultColor: "#FFBF00",
              type: "marker",
              icon: `<svg fill="#000000" height="200px" width="200px" version="1.1" id="Icons" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 32 32" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path d="M17.6,6L6.9,16.7c-0.2,0.2-0.3,0.4-0.3,0.6L6,23.9c0,0.3,0.1,0.6,0.3,0.8C6.5,24.9,6.7,25,7,25c0,0,0.1,0,0.1,0l6.6-0.6 c0.2,0,0.5-0.1,0.6-0.3L25,13.4L17.6,6z"></path> <path d="M26.4,12l1.4-1.4c1.2-1.2,1.1-3.1-0.1-4.3l-3-3c-0.6-0.6-1.3-0.9-2.2-0.9c-0.8,0-1.6,0.3-2.2,0.9L19,4.6L26.4,12z"></path> </g> <g> <path d="M28,29H4c-0.6,0-1-0.4-1-1s0.4-1,1-1h24c0.6,0,1,0.4,1,1S28.6,29,28,29z"></path> </g> </g></svg>`,
            },
          },
        },
        data:
          notesLength >= 1
            ? JSON.parse(
                notes[headCaption][getIndex(headCaption, caption, titleObject)]
                  .notes
              )
            : null,
        onChange: async function () {
          await editor.save().then((data) => setText(data));
        },
        placeholder: "Let`s create an awesome content!",
      });
    }
  }, [notes, setText, headCaption, caption, titleObject, notesLength]);

  function bottomScroll() {
    bottomRef.current &&
      bottomRef.current.scrollIntoView({ behavior: "smooth" });
  }
  setTimeout(() => {
    bottomScroll();
  }, 1);

  async function getChat() {
    if (msg.length <= 0) {
      alert("Please Write Message !");
      return;
    }
    setInput(true);
    bottomScroll();
    displayMessages.push([msg, "sent"]);
    bottomScroll();
    setMsg("");
    let data = JSON.stringify({
      query: msg,
      userid: user.id,
      user_id: user.id,
      filename: filename1,
    });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://api.gyanibooks.com/query_fine_tune/",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        bottomScroll();
        console.log(response);
        displayMessages.push([response.data.response, "rcvd"]);
        bottomScroll();
        setInput(false);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  async function uploadgd(url, name, id) {
    let data = JSON.stringify({
      url: url,
      filename: name,
      user_id: id,
    });
    setfilename1(name);
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://api.gyanibooks.com/send_drive_doc/",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        alert(response.data.message);
      })
      .catch((error) => {
        console.error(error);
      });
  }
  const handleView = (url) => {
    window.open(url, "_blank");
  };
  // const handleSelectedOptionChange = (event) => {
  //   setSelectedOption(event.target.value);
  // };
  // const handleClick = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };

  // const handleClose = (option) => {
  //   if (option) {
  //     setSelectedOption(option);
  //   }
  //   setAnchorEl(null);
  // };
  //  handle outside click of inline menu

  const setBookmark = async (id, title, paperId, url) => {
    try {
      //   const isAlreadyBookmarked = ;

      // if (isAlreadyBookmarked) {
      //   console.log("Paper is already bookmarked.");
      //   setisBookmarked(true);
      //   return;
      // }
      let data = JSON.stringify({
        title: title,
        userid: id,
        url: url,
        paper_id: paperId,
      });

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: "https://api.gyanibooks.com/paper_bookmark/",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      const response = await axios.request(config);
      setisBookmarked(true);
      console.log(JSON.stringify(response.data));
    } catch (error) {
      setisBookmarked(false);
      if (error.response) {
        console.error("Server responded with an error:", error.response.data);
        console.error("Status code:", error.response.status);
      } else if (error.request) {
        console.error("No response received from the server");
      } else {
        console.error("Error setting up the request:", error.message);
      }
    }
  };

  const uploadlocalfile = async () => {
    if (!localfile) return;
    let data = new FormData();
    data.append("file", localfile);
    data.append("user_id", user.id);
    data.append("filename", localfile.name);

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://api.gyanibooks.com/save_doc_api/",
      headers: {
        ...data.getHeaders(),
      },
      data: data,
    };

    try {
      let response = await axios.request(config);
      setshowchatwithpdf(true);
      setshowsearch(false);
      console.log(response);
    } catch (error) {
      alert(error);
    }
  };

  // const [plus1, setplus1] = useState("false");

  const DISCOVERY_DOCS = [
    "https://www.googleapis.com/discovery/v1/apis/drive/v2/rest",
  ];
  const SCOPES = "https://www.googleapis.com/auth/drive.metadata.readonly";

  const initClient = () => {
    setIsLoadingGoogleDriveApi(true);
    gapi.client
      .init({
        apiKey: "AIzaSyCsDxeAsBSly3Zs66-qeoYqE_SFyp3ydxc",
        clientId:
          "782574336068-468vpe6lpv8v1r9d025h3gh74dmdcvpj.apps.googleusercontent.com",
        discoveryDocs: DISCOVERY_DOCS,
        scope: SCOPES,
      })
      .then(
        function () {
          // Listen for sign-in state changes.
          gapi.auth2.getAuthInstance().isSignedIn.listen(updateSigninStatus);

          // Handle the initial sign-in state.
          updateSigninStatus(gapi.auth2.getAuthInstance().isSignedIn.get());
        },
        function (error) {
          console.log(error);
        }
      );
  };

  const updateSigninStatus = (isSignedIn) => {
    if (isSignedIn) {
      // Set the signed in user
      setSignedInUser(gapi.auth2.getAuthInstance().currentUser.le.wt.Ad);
      setIsLoadingGoogleDriveApi(false);
      // list files if user is authenticated
      listFiles();
    } else {
      // prompt user to sign in
      handleAuthClick();
    }
  };

  const listFiles = (searchTerm = null) => {
    setIsFetchingGoogleDriveFiles(true);
    gapi.client.drive.files
      .list({
        fields: "nextPageToken, items(id, title, mimeType)",
        maxResults: 3000,
      })
      .then(function (response) {
        setIsFetchingGoogleDriveFiles(false);
        setListDocumentsVisibility(true);
        const res = JSON.parse(response.body);
        setDocuments(res.items);
        // console.log(res.items);
      });
  };

  const handleAuthClick = (event) => {
    gapi.auth2.getAuthInstance().signIn();
  };

  const handleClientLoad = () => {
    gapi.load("client:auth2", initClient);
  };

  const getfile1 = async (realFileId) => {
    gapi.client.drive.files
      .get({
        fileId: realFileId,
      })
      .then(function (response) {
        const res = JSON.parse(response.body);
        uploadgd(res.alternateLink, res.title, user.id);
        setshowchatwithpdf(true);
        setshowsearch(false);
      });
  };

  const search1 = async () => {
    setDocuments(
      documents.filter(
        (e) => e.title.toUpperCase() === searchTerm.toUpperCase()
      )
    );
  };

  let vertical = "top";
  let horizontal = "right";

  let user = JSON.parse(localStorage.getItem("user"));

  // const CustomDragHandleMenu = (props) => {
  //   return (
  //     <DragHandleMenu>
  //       <RemoveBlockButton {...props}>Delete</RemoveBlockButton>
  //       <DragHandleMenuItem
  //         closeMenu={props.closeMenu}
  //         onClick={() => {
  //           summarise(props.block.content[0].text.toString());
  //           props.closeMenu();
  //         }}
  //       >
  //         Summarise
  //       </DragHandleMenuItem>
  //       <DragHandleMenuItem
  //         closeMenu={props.closemenu}
  //         onClick={() => {
  //           // console.log(props.block.content[0].text.toString());
  //           // elaborate(props.block.content[0].text.toString());
  //           props.closeMenu();
  //         }}
  //       >
  //         Elaborate
  //       </DragHandleMenuItem>
  //       <DragHandleMenuItem
  //         closeMenu={props.closemenu}
  //         onClick={() => {
  //           setGenerateDialog(true);
  //           props.closeMenu();
  //         }}
  //       >
  //         Generate
  //       </DragHandleMenuItem>
  //     </DragHandleMenu>
  //   );
  // };

  const summarise = async (text) => {
    setLoading(true);
    let data = JSON.stringify({
      text:
        text + `For this text use the tone as ${tone}, with emotion ${style}`,
      lang: language,
      userId: user.id,
    });
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://api.gyanibooks.com/inde_summary/",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    await axios
      .request(config)
      .then((response) => {
        ref.current.save().then(() =>
          ref.current.blocks.insert("paragraph", {
            text: response.data,
            //  "level": 3
          })
        );
        setLoading(false);
        // document.getElementById("bottom").scrollIntoView();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // this is a helper function to print the text retunred from the api in a formatted way -->
  const enterData = async (text) => {
    setLoading(true);
    const lines = text.split("\n").filter((line) => line.trim() !== "");
    let isOrdered = false;
    let orderedList = [];
    lines.forEach((line) => {
      const trimmedLine = line.trim();
      if (/^\d+(\.)/.test(trimmedLine)) {
        if (!isOrdered) {
          isOrdered = true;
        }
        const finalLine = trimmedLine.replace(/^\d+(\.|\))/, "").trim();
        if (finalLine !== "") {
          orderedList.push(finalLine);
        }
      } else {
        if (isOrdered) {
          if (orderedList.length > 0) {
            ref.current.blocks.insert("list", {
              style: "ordered",
              items: orderedList,
            });
            orderedList = [];
          }
          isOrdered = false;
        }
        ref.current.blocks.insert("paragraph", {
          text: trimmedLine,
        });
      }
    });

    // Insert ordered list if there are items remaining in orderedList
    if (orderedList.length > 0) {
      ref.current.blocks.insert("list", {
        style: "ordered",
        items: orderedList,
      });
    }
  };

  // const enterTestData = async (text) => {
  //   console.log(ref.current.blocks);
  //   // ref.current.blocks.clear();
  //   ref.current.blocks.insert("paragraph", {
  //     text: text,
  //   });
  // };

  const elaborate = async (text) => {
    setLoading(true);
    let data = JSON.stringify({
      text: text + `For this use  the tone as ${tone}, with emotion ${style}`,
      lang: language,
      userid: user.id,
    });
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://api.gyanibooks.com/ind_Elaborate/",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    let res = null;
    await axios
      .request(config)
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.log(error);
      });
    console.log(ref.current.blocks);
    enterData(res.data);
    setLoading(false);
  };

  const elaborateContextSubMenu = async (text, option1, option2) => {
    setLoading(true);
    let data = JSON.stringify({
      text:
        text +
        `,${option1} this text ${option2} and return only the text provided.`,
      lang: "English",
      userid: user.id,
    });
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://api.gyanibooks.com/ind_Elaborate/",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    let res = null;
    await axios
      .request(config)
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.log(error);
      });
    enterData(res.data);
  };
  const elaborateContextSubMenuTranslate = async (text, option2) => {
    setLoading(true);
    let data = JSON.stringify({
      text: text + `,Translate this in` + option2,
      lang: option2,
      userid: user.id,
    });
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://api.gyanibooks.com/ind_Elaborate/",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    await axios
      .request(config)
      .then((response) => {
        ref.current.save().then(() =>
          ref.current.blocks.insert("paragraph", {
            text: response.data,
            //  "level": 3
          })
        );
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const elaborateCustom = async (text, aiText) => {
    setLoading(true);
    let data = JSON.stringify({
      text: text + aiText,
      lang: "English",
      userid: user.id,
    });
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://api.gyanibooks.com/ind_Elaborate/",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    let res = null;
    await axios
      .request(config)
      .then((response) => {
        res = response;
        enterData(res.data);
      })
      .catch((error) => {
        console.log(error);
      });

    // newRes = res.data.replace(/\n\d+\./g, "");
    // ref.current.save().then(() =>
    //   ref.current.blocks.insert("paragraph", {
    //     text: newRes,
    //     // level: 3,
    //   })
    // );
    setLoading(false);
    // setLoading(false);
    setAiText("");
    setGenerateInput("");
  };
  const handleInlineResult = (value) => {
    setInlineResult(value ? value : inlineResult);
  };
  useEffect(() => {
    console.log(inlineResult);
  }, [inlineResult]);

  const elaborateInlineCustom = async (aiText) => {
    setLoading(true);
    let data = JSON.stringify({
      text: inlineResult + "," + aiText,
      lang: "English",
      userid: user.id,
    });
    console.log(data);
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://api.gyanibooks.com/ind_Elaborate/",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    let res = null;
    await axios
      .request(config)
      .then((response) => {
        res = response;
        // enterData(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
    try {
      setShowInlineResult((prevResults) => {
        if (Array.isArray(prevResults)) {
          return [...prevResults, res.data];
        } else return [res.data];
      });
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  const research = async (loadMore = false) => {
    setLoading(true);
    setSources([]);

    const newOffset = loadMore ? offset + 10 : 10;

    var res;
    if (academic) {
      res = await axios.post(
        "https://api.gyanibooks.com/search_publication/",
        {
          //DATA TO POST
          keyword: researchText,
          limit: 10,
          offset: newOffset,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      setOffset(newOffset);
      setResearchResponse((prevResults) =>
        loadMore ? [...prevResults, ...res.data.data] : res.data.data
      );
      if (!loadMore && academic) {
        setShowLoadMore(true);
      }
    } else {
      try {
        const res = await axios.post(
          "https://api.gyanibooks.com/wiki_search/",
          {
            query: researchText,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        // console.log(res.data);
        setResearchResponse(res.data);
      } catch (error) {
        console.log(error);
      }
    }
    setLoading(false);
  };
  const handleCitations = (citations) => {
    setCitations(citations);
  };
  useEffect(() => {
    console.log("citations", citations);
  }, [citations]);
  const filesfromfolder = async (fid) => {
    try {
      const res = await axios.get(
        `https://www.googleapis.com/drive/v2/files?q='${fid}'+in+parents&key=AIzaSyCsDxeAsBSly3Zs66-qeoYqE_SFyp3ydxc`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      setshow1(true);
      setshowfolder(true);
      setlength1(res.data.items.length);
      setfoldersdata(res.data.items);
    } catch (err) {
      setlength1(0);
      //  console.log(err)
    }
  };

  const generate = async () => {
    setLoading(true);
    const res = await axios.post(
      "https://bot.gyanibooks.com/api/ind_Elaborate/",
      {
        //DATA TO POST
        text: generateInput,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    ref.current.save().then(() =>
      ref.current.blocks.insert("paragraph", {
        text: res.data,
        //  "level": 3
      })
    );
    // document.getElementById("bottom").scrollIntoView();
    setLoading(false);
    setLoading(false);
  };

  async function detectAI() {
    let printableElement = document.getElementById("printable");
    if (printableElement) {
      setLoading1(true);
      let redactorElement = printableElement.querySelector(
        ".codex-editor__redactor"
      );
      const inner = redactorElement.innerHTML;
      const startIndex = inner.indexOf("Text");
      const result = startIndex !== -1 ? inner.substring(0, startIndex) : inner;
      let data = JSON.stringify({
        text: result.trim(),
        userid: user.id,
      });
      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: "https://api.gyanibooks.com/inde_ai_detect/",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      const res = await axios.request(config);

      let real = 1 - res.data.fake;
      // console.log(real);
      setLoading1(false);
      setScore(Math.floor(real * 100));
    }
  }

  async function saveText() {
    setSyncing(true);
    setNotesName(
      user.personalisation.id +
        "." +
        category +
        "." +
        (request === "PUT" ? editTitle : newNotesTitle)
    );
    if (request === "POST" && newNotesTitle.length <= 3) {
      setOpen(true);
      setSnackbarText("Title must be more than 3 characters!");
      setSyncing(false);
      return;
    }

    let payload = {
      user: user.personalisation.id,
      title: request === "PUT" ? editTitle : newNotesTitle,
      category: category === undefined ? "Uncategorised" : category,
      notes: JSON.stringify(text),
    };

    try {
      const res =
        request === "PUT"
          ? await axios.put(
              "https://api.gyanibooks.com/library/notes/",
              payload
            )
          : await axios.post(
              "https://api.gyanibooks.com/library/notes/",
              payload
            );

      if (res.status === 200) {
        setOpen(res.data);
        setSnackbarText(res.data);
        setSavedNotes(text);
        setSyncing(false);
        fetchNotes();
        return true;
      }
    } catch (error) {
      console.error("Error saving notes:", error);
      // Handle the error, e.g., set an error state or display an error message
      setSyncing(false);
      // Optionally rethrow the error if you want to propagate it further
      throw error;
    }
  }

  useEffect(() => {
    if (sty === "true") {
      setTab(1);
      setlistvisible(true);
    }
  }, [sty]);

  const gettransaction = useCallback(() => {
    let data = JSON.stringify({
      userid: user.id,
    });
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://api.gyanibooks.com/sub_details/",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        setshowprogressbar(
          response.data[response.data.length - 1]?.payment_confimation
        );
      })
      .catch((error) => {
        console.log(error);
      });
  }, [user.id]);

  const handleInsert = async () => {
    enterData(inlineResult);
    setLoading(false);
    setInlineMenu(false);
    setShowInlineResult([]);
    setInlineResult([]);
  };
  const handleTryAgain = async (texty) => {
    setLoading(true);
    if (texty !== "") {
      let data = JSON.stringify({
        text: showInlineResult + "," + texty,
        lang: "English",
        userid: user.id,
      });
      console.log(data);
      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: "https://api.gyanibooks.com/ind_Elaborate/",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      let res = null;
      await axios
        .request(config)
        .then((response) => {
          res = response;
        })
        .catch((error) => {
          console.log(error);
        });
      try {
        setShowInlineResult((prevResults) => {
          if (Array.isArray(prevResults)) {
            return [...prevResults, res.data];
          } else return [res.data];
        });
      } catch (error) {
        console.error(error);
      }
      setLoading(false);
    } else if (contextMenuOption !== "") {
      let data = JSON.stringify({
        text:
          inlineResult +
          `Modify this text according to the following instruction: ${contextMenuOption} and return only the modified text.`,
        lang: "English",
        userid: user.id,
      });
      console.log(data);
      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: "https://api.gyanibooks.com/ind_Elaborate/",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      let res = null;
      await axios
        .request(config)
        .then((response) => {
          res = response;
        })
        .catch((error) => {
          console.log(error);
        });
      try {
        setShowInlineResult((prevResults) => {
          if (Array.isArray(prevResults)) {
            return [...prevResults, res.data];
          } else return [res.data];
        });
      } catch (error) {
        console.error(error);
      }
      setLoading(false);
    } else {
      if (contextSubMenuPrimaryOption === "Translate") {
        await elaborateInlineContextSubMenuTranslate(
          inlineResult,
          inlineLanguage
        );
      } else {
        await elaborateInlineContextSubMenu(
          inlineResult,
          contextSubMenuPrimaryOption,
          contextSubMenuSecondaryOption
        );
      }
    }
    setLoading(false);
  };
  const handleDiscard = async () => {
    setContextMenuOption("");
    setInlineMenu(false);
    setShowInlineResult([]);
  };
  const handleInlineContextMenu = async (event) => {
    handleInlineContextMenuOption(event);
  };
  const handleInlineContextMenuOption = async (event) => {
    setAnchorEl(null);
    const option = event.target.textContent;
    console.log("option:", option);
    if (inlineResult) {
      setContextMenuOption(option);
      await elaborateInlineContextMenu(inlineResult, option);
    }
    setLoading(false);
    // setContextMenuOption("");
  };
  const elaborateInlineContextMenu = async (text, instruction) => {
    setLoading(true);
    let data = JSON.stringify({
      text:
        text +
        `Modify this text according to the following instruction: ${instruction} and return only the modified text.`,
      lang: "English",
      userid: user.id,
    });
    console.log(data);
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://api.gyanibooks.com/ind_Elaborate/",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    let res = null;
    await axios
      .request(config)
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.log(error);
      });
    try {
      setShowInlineResult((prevResults) => {
        if (Array.isArray(prevResults)) {
          return [...prevResults, res.data];
        } else return [res.data];
      });
    } catch (error) {
      console.error(error);
    }
  };
  const handleContextMenuOption = async (event) => {
    setAnchorEl(null);
    const option = event.target.textContent;
    console.log("option:", option);
    if (generateInput) {
      setContextMenuOption(option);
      await elaborateContextMenu(generateInput, option);
    }
    setLoading(false);
    setContextMenuOption("");
  };
  const elaborateContextMenu = async (text, instruction) => {
    setLoading(true);
    let data = JSON.stringify({
      text:
        text +
        `Modify this text according to the following instruction: ${instruction} and return only the modified text.`,
      lang: "English",
      userid: user.id,
    });
    console.log(
      text +
        `Modify this text according to the following instruction: ${instruction} and return only the modified text.`
    );
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://api.gyanibooks.com/ind_Elaborate/",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    let res = null;
    await axios
      .request(config)
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.log(error);
      });
    enterData(res.data);
  };
  const handleInlineContextSubMenuPrimaryOption = async (option) => {
    await setContextSubMenuPrimaryOption(option);
  };
  const handleContextSubMenuPrimaryOption = async (option) => {
    await setContextSubMenuPrimaryOption(option);
  };
  const handleInlineContextSubMenuSecondary = async (event) => {
    handleInlineContextSubMenuSecondaryOption(event);
  };
  const handleInlineContextSubMenuSecondaryOption = async (event) => {
    setAnchorEl(null);
    setAnchorEl2(null);
    setAnchorEl3(null);
    setAnchorEl4(null);
    const option = event.target.textContent;
    setContextSubMenuSecondaryOption(option);

    if (contextSubMenuPrimaryOption === "Translate") {
      await elaborateInlineContextSubMenuTranslate(inlineResult, option);
    } else {
      await elaborateInlineContextSubMenu(
        inlineResult,
        contextSubMenuPrimaryOption,
        option
      );
    }
    setLoading(false);
  };

  const elaborateInlineContextSubMenuTranslate = async (text, option2) => {
    setLoading(true);
    setInlineLanguage(option2);
    let data = JSON.stringify({
      text: text + `,Translate this in` + option2,
      lang: option2,
      userid: user.id,
    });
    console.log(data);
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://api.gyanibooks.com/ind_Elaborate/",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    let res = null;
    await axios
      .request(config)
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.log(error);
      });
    try {
      setShowInlineResult((prevResults) => {
        if (Array.isArray(prevResults)) {
          return [...prevResults, res.data];
        } else return [res.data];
      });
    } catch (error) {
      console.error(error);
    }

    setLoading(false);
  };
  const elaborateInlineContextSubMenu = async (text, option1, option2) => {
    setLoading(true);
    let data = JSON.stringify({
      text:
        text +
        `,${option1} this text ${option2} and return only the text provided.`,
      lang: "English",
      userid: user.id,
    });
    console.log(data);
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://api.gyanibooks.com/ind_Elaborate/",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    let res = null;
    await axios
      .request(config)
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.log(error);
      });
    try {
      setShowInlineResult((prevResults) => {
        if (Array.isArray(prevResults)) {
          return [...prevResults, res.data];
        } else return [res.data];
      });
    } catch (error) {
      console.error(error);
    }

    setLoading(false);
  };
  const handleContextSubMenuSecondaryOption = async (event) => {
    setAnchorEl(null);
    setAnchorEl2(null);
    setAnchorEl3(null);
    setAnchorEl4(null);
    const option = event.target.textContent;
    setContextSubMenuSecondaryOption(option);

    if (contextSubMenuPrimaryOption === "Translate") {
      await elaborateContextSubMenuTranslate(generateInput, option);
    } else {
      await elaborateContextSubMenu(
        generateInput,
        contextSubMenuPrimaryOption,
        option
      );
    }

    setLoading(false);
    setContextSubMenuPrimaryOption("");
    setContextSubMenuSecondaryOption("");
    setInlineMenu(false);
  };

  useEffect(() => {
    gettransaction();
  }, [gettransaction]);

  const handleKeyPress = (event) => {
    if (event.ctrlKey && event.key === "p") {
      handlePrint();
    }
    if (event.ctrlKey && event.key === "s") {
      handleSave();
    }
  };

  const handlePrint = () => {
    printNotes();
  };
  const handleSave = () => {
    saveText();
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyPress);
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, []);

  const printNotes = () => {
    let printableElement = document.getElementById("printable");

    if (printableElement) {
      let redactorElement = printableElement.querySelector(
        ".codex-editor__redactor"
      );

      if (redactorElement) {
        let printContents = redactorElement.innerHTML;
        let printWindow = window.open("", "_blank");

        if (printWindow) {
          printWindow.document.open();
          printWindow.document.write(
            "<html><head><title>Print</title></head><body>"
          );
          printWindow.document.write(printContents);
          printWindow.document.write("</body></html>");
          printWindow.document.close();

          printWindow.print();
          printWindow.close();
        } else {
          console.error("Failed to open the print window");
        }
      } else {
        console.error("Element with class 'codex-editor__redactor' not found");
      }
    } else {
      console.error("Element with ID 'printable' not found");
    }
  };

  const { t } = useTranslation();

  const handleTabChange = (newValue) => {
    setTab(newValue);
  };

  const handleMenuBack = () => {
    setSideMenu(false);
    setIsOptionsVisible(true);
    setre("false");
    setTab(2);
  };

  // const handleTabChange = (newValue) => {
  //   setTab(newValue);
  // };

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };
  // function a11yProps(index) {
  //   return {
  //     id: `vertical-tab-${index}`,
  //     "aria-controls": `vertical-tabpanel-${index}`,
  //   };
  // }
  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`vertical-tabpanel-${index}`}
        aria-labelledby={`vertical-tab-${index}`}
        {...other}
      >
        {value === index && (
          <div style={{ p: 3 }}>
            <Typography>{children}</Typography>
          </div>
        )}
      </div>
    );
  }

  return (
    <div
      className="w-[100%] h-full flex flex-col items-center justify-between scrollbar-hide top-0"
      style={{ fontFamily: "Work Sans" }}
      onContextMenu={(e) => {
        setSelectedText(window.getSelection().toString());
        e.preventDefault();
        setClicked(true);
        setPoints({
          x: e.pageX,
          y: e.pageY,
        });
      }}
    >
      <div className="lg:hidden noprint " style={{ position: "", bottom: 20 }}>
        <BottomNavigation showLabels value={"chat"}>
          <BottomNavigationAction
            className="!text-[#428cfb] w-2"
            label="Research"
            icon={
              <>
                {re === "true" ? (
                  <Science
                    onClick={() => {
                      setSideMenu(true);
                      setre("false");
                    }}
                    className="pulse"
                    color="primary"
                  />
                ) : (
                  <Science
                    onClick={() => {
                      setSideMenu(true);
                      setre("false");
                      setMobileDrawer(true);
                      setIsOptionsVisible(false);
                      setTab(2);
                    }}
                    color="primary"
                  />
                )}
              </>
            }
          />
          <Button
            className="!bg-white !p-0"
            id="demo-customized-button"
            aria-controls={openMainMenu ? "demo-customized-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={openMainMenu ? "true" : undefined}
            variant="contained"
            disableElevation
            onClick={(event) => {
              setAnchorEl(event.currentTarget);
            }}
          >
            <BottomNavigationAction
              className="!text-[#428cfb] w-2 !p-0 !h-2"
              icon={
                <>
                  <FilterAlt />
                  <span className="!text-[#428cfb] z-20 text-xs">Refine</span>
                </>
              }
            />
          </Button>
          <StyledMenu
            id="demo-customized-menu"
            MenuListProps={{
              "aria-labelledby": "demo-customized-button",
            }}
            anchorEl={anchorEl}
            open={openMainMenu}
            onClose={() => {
              setAnchorEl(null);
            }}
          >
            <MenuItem
              className="!p-2 !text-[0.875rem] !text-black"
              onClick={handleContextMenuOption}
            >
              Improve fluency
            </MenuItem>
            <Divider sx={{ my: 0.5 }} />
            <MenuItem disableRipple className="!w-full !p-0">
              <Button
                className="!w-full !bg-white !text-black !justify-start !normal-case !p-2"
                aria-controls={
                  openSubMenuParaphrase
                    ? "demo-customized-submenu-paraphrase"
                    : undefined
                }
                aria-haspopup="true"
                aria-expanded={openSubMenuParaphrase ? "true" : undefined}
                variant="contained"
                disableElevation
                onClick={(event) => {
                  setAnchorEl2(event.currentTarget);
                  handleContextSubMenuPrimaryOption("Paraphrase");
                }}
              >
                <MoreVert />
                Paraphrase
              </Button>
              <StyledMenu
                id="demo-customized-menu-paraphrase"
                MenuListProps={{
                  "aria-labelledby": "demo-customized-button-paraphrase",
                }}
                anchorEl={anchorEl2}
                open={openSubMenuParaphrase}
                onClose={() => {
                  setAnchorEl2(null);
                }}
              >
                <MenuItem onClick={handleContextSubMenuSecondaryOption}>
                  Academically
                </MenuItem>
                <MenuItem onClick={handleContextSubMenuSecondaryOption}>
                  Casually
                </MenuItem>
                <MenuItem onClick={handleContextSubMenuSecondaryOption}>
                  Persuasively
                </MenuItem>
                <MenuItem onClick={handleContextSubMenuSecondaryOption}>
                  Boldly
                </MenuItem>
                <MenuItem onClick={handleContextSubMenuSecondaryOption}>
                  Friendly
                </MenuItem>
              </StyledMenu>
            </MenuItem>
            <Divider sx={{ my: 0.5 }} />
            <MenuItem disableRipple className="!w-full !p-0">
              <Button
                className="!w-full !bg-white !text-black !justify-start !normal-case !p-2"
                id="demo-customized-button-simplify"
                aria-controls={
                  openSubMenuSimplify
                    ? "demo-customized-menu-simplify"
                    : undefined
                }
                aria-haspopup="true"
                aria-expanded={openSubMenuSimplify ? "true" : undefined}
                variant="contained"
                disableElevation
                onClick={(event) => {
                  setAnchorEl3(event.currentTarget);
                  handleContextSubMenuPrimaryOption("Simplify");
                }}
              >
                <MoreVert />
                Simplify
              </Button>
              <StyledMenu
                id="demo-customized-menu-simplify"
                MenuListProps={{
                  "aria-labelledby": "demo-customized-button-simplify",
                }}
                anchorEl={anchorEl3}
                open={openSubMenuSimplify}
                onClose={() => {
                  setAnchorEl3(null);
                }}
              >
                <MenuItem onClick={handleContextSubMenuSecondaryOption}>
                  Academically
                </MenuItem>
                <MenuItem onClick={handleContextSubMenuSecondaryOption}>
                  Casually
                </MenuItem>
                <MenuItem onClick={handleContextSubMenuSecondaryOption}>
                  Persuasively
                </MenuItem>
                <MenuItem onClick={handleContextSubMenuSecondaryOption}>
                  Boldly
                </MenuItem>
                <MenuItem onClick={handleContextSubMenuSecondaryOption}>
                  Friendly
                </MenuItem>
              </StyledMenu>
            </MenuItem>
            <Divider sx={{ my: 0.5 }} />
            <MenuItem
              className="!p-2 !text-[0.875rem] !text-black"
              onClick={handleContextMenuOption}
              disableRipple
            >
              Make longer
            </MenuItem>
            <Divider sx={{ my: 0.5 }} />
            <MenuItem disableRipple className="!w-full !p-0">
              <Button
                className="!w-full !bg-white !text-black !justify-start !normal-case !p-2"
                id="demo-customized-button-translate"
                aria-controls={
                  openSubMenuTranslate
                    ? "demo-customized-menu-translate"
                    : undefined
                }
                aria-haspopup="true"
                aria-expanded={openSubMenuTranslate ? "true" : undefined}
                variant="contained"
                disableElevation
                onClick={(event) => {
                  setAnchorEl4(event.currentTarget);
                  handleContextSubMenuPrimaryOption("Translate");
                }}
              >
                <MoreVert />
                Translate
              </Button>
              <StyledMenu
                id="demo-customized-menu-translate"
                MenuListProps={{
                  "aria-labelledby": "demo-customized-button-translate",
                }}
                anchorEl={anchorEl4}
                open={openSubMenuTranslate}
                onClose={() => {
                  setAnchorEl4(null);
                }}
              >
                <MenuItem onClick={handleContextSubMenuSecondaryOption}>
                  Spanish
                </MenuItem>
                <MenuItem onClick={handleContextSubMenuSecondaryOption}>
                  German
                </MenuItem>
                <MenuItem onClick={handleContextSubMenuSecondaryOption}>
                  French
                </MenuItem>
                <MenuItem onClick={handleContextSubMenuSecondaryOption}>
                  Hindi
                </MenuItem>
                <MenuItem onClick={handleContextSubMenuSecondaryOption}>
                  Japanese
                </MenuItem>
                <MenuItem onClick={handleContextSubMenuSecondaryOption}>
                  English
                </MenuItem>
              </StyledMenu>
            </MenuItem>
            <Divider sx={{ my: 0.5 }} />
            <MenuItem
              className="!p-2 !text-[0.875rem] !text-black"
              onClick={handleContextMenuOption}
            >
              Write opposing argument
            </MenuItem>
            <MenuItem
              className="!p-2 !text-[0.875rem] !text-black"
              onClick={handleContextMenuOption}
            >
              Write with more depth
            </MenuItem>
            <MenuItem
              className="!p-2 !text-[0.875rem] !text-black"
              onClick={handleContextMenuOption}
            >
              Continue writing
            </MenuItem>
          </StyledMenu>

          <BottomNavigationAction
            className="!text-[#428cfb] w-2"
            label="Generate"
            icon={
              <>
                <AutoFixHigh />
              </>
            }
            onClick={() => {
              setGenerateDialog(true);
            }}
          />
          <BottomNavigationAction
            className=" !text-[#428cfb] w-2"
            label="Share"
            icon={
              <>
                {sar === "true" ? (
                  <Share
                    className="pulse"
                    onClick={() => {
                      shareDialog.push(Notesuuid);
                      setsar("false");
                      setsav("true");
                    }}
                  />
                ) : (
                  <Share onClick={() => shareDialog.push(Notesuuid)} />
                )}
              </>
            }
          />
          <BottomNavigationAction
            className="!text-[#428cfb] w-2"
            label={timerStart ? convertStoMs(parseInt(time / 1000)) : "Timer"}
            icon={
              timerStart ? (
                <Stop color="info" onClick={() => handleTimerStop()} />
              ) : (
                <>
                  {timerd === "true" ? (
                    <Timer
                      color="info"
                      className="pulse"
                      onClick={() => {
                        handleTimerStart();
                        settimerd("false");
                        setcompletiond("true");
                      }}
                    />
                  ) : (
                    <Timer
                      color="info"
                      onClick={() => {
                        handleTimerStart();
                      }}
                    />
                  )}
                </>
              )
            }
          />
        </BottomNavigation>
      </div>
      <div className="flex justify-center items-center w-[20%]">
        <Drawer
          anchor={"right"}
          open={sideMenu}
          size="sm"
          onClose={() => setSideMenu(false)}
          variant="temporary"
        >
          <div
            className=" text-center flex justify-center items-center flex-col mb-5 lg:max-w-[42rem]"
            style={{ fontFamily: "Work Sans" }}
          >
            <div className="flex flex-row justify-between items-center w-[90%] mt-5 mb-2">
              <button
                className="flex justify-start items-center  rounded-full  hover:bg-[#EFEFFD]"
                onClick={handleMenuBack}
              >
                <IconButton
                  size="large"
                  type="button"
                  className="hover:opacity-[0.5]"
                >
                  <LastPage />
                </IconButton>
              </button>

              {/* <IconButton
                size="large"
                className="px-[0.5px] !hover:bg-[#EFEFFD]"
                onClick={() => printNotes()}
              >
                <Print />
              </IconButton> */}
              <>
                {ai1 === "true" ? (
                  <>
                    {mobileDrawer && (
                      <>
                        <Button
                          style={{
                            background: "rgb(66, 140, 251)",
                            color: "white",
                            padding: "2em",
                          }}
                          className="!p-1 !rounded-lg"
                          variant="outlined"
                          onClick={() => printNotes()}
                          startIcon={<Print />}
                        >
                          Print
                        </Button>
                      </>
                    )}
                    <button
                      aria-label="add"
                      size="medium"
                      className="pulse  !rounded-full lg:px-3 bg-green-900 hover:bg-green-700 text-white w-auto flex flex-row px-[2px] py-1"
                      onClick={() => {
                        detectAI();
                        setSideMenu(false);
                        setai1("false");
                        setft("true");
                      }}
                    >
                      <span
                        className=" lg:block !lg:px-2 "
                        style={{ fontFamily: "Work Sans" }}
                      >
                        Originality
                      </span>
                      {""}
                      &nbsp;
                      <span className="font-bold">{score}%</span>
                      {""}
                      <Refresh className={`${loading1 && "animate-spin"} `} />
                    </button>
                  </>
                ) : (
                  <>
                    {mobileDrawer && (
                      <>
                        <Button
                          style={{
                            background: "rgb(66, 140, 251)",
                            color: "white",
                            padding: "2em",
                          }}
                          className="!p-1 !rounded-lg"
                          variant="outlined"
                          onClick={() => printNotes()}
                          startIcon={<Print />}
                        >
                          Print
                        </Button>
                      </>
                    )}
                    <button
                      aria-label="add"
                      size="medium"
                      className="!shadow-none !rounded-full lg:px-3 bg-green-900 hover:bg-green-700 text-white w-auto flex flex-row px-[2+px] py-1"
                      onClick={() => detectAI()}
                    >
                      <span
                        className=" lg:block !lg:px-2 "
                        style={{ fontFamily: "Work Sans" }}
                      >
                        Originality
                      </span>
                      {""}
                      &nbsp;
                      <span className="font-bold">{score}%</span>
                      {""}
                      <Refresh className={`${loading1 && "animate-spin"} `} />
                    </button>
                  </>
                  // </Tooltip>
                )}
              </>
            </div>
            <div className="rounded-2xl bg-gray-200 text-lg  w-full hidden ">
              <Bolt className="text-blue-400" /> Your balance: 9,313 premium
              words
            </div>
            {mobileDrawer ? (
              <div
                className="flex flex-col container w-screen justify-center mx-auto"
                style={{ fontFamily: "Work Sans" }}
              >
                {isOptionsVisible ? (
                  <div className="flex text-center my-24  mb-2 m-auto w-[90%] ">
                    <div className=" m-2 flex flex-col w-screen mx-auto bg-[#EFEFFD] rounded-lg overflow-hidden">
                      <Tooltip title={"Summarise"} arrow placement="left">
                        <button
                          style={{
                            backgroundColor: tab === 0 ? "#428CFB" : "#EFEFFD",
                            color: tab === 0 ? "white" : "#428CFB",
                            padding: "2em",
                          }}
                          className="border border-transparent rounded-lg  flex flex-row justify-center items-center space-x-2 py-2 "
                          onClick={() => {
                            setTab(0);
                            setlistvisible(true);
                            setshowsearch(false);
                            setshowchatwithpdf(false);
                            setIsOptionsVisible(false);
                          }}
                        >
                          <p
                            className=" text-[1.2em] font-[700] px-8 max-[645px]:px-1 "
                            style={{ fontFamily: "Work Sans" }}
                          >
                            SUMMARISE
                          </p>
                        </button>
                      </Tooltip>
                      <Tooltip title={"Elaborate"} arrow placement="left">
                        <button
                          style={{
                            backgroundColor: tab === 1 ? "#428CFB" : "#EFEFFD",
                            color: tab === 1 ? "white" : "#428CFB",
                            padding: "2em",
                          }}
                          className="border border-transparent rounded-lg  flex flex-row justify-center items-center space-x-2 py-2  w-full"
                          onClick={() => {
                            setTab(1);
                            setlistvisible(true);
                            setshowsearch(false);
                            setshowchatwithpdf(false);
                            setIsOptionsVisible(false);
                          }}
                        >
                          <p
                            className=" text-[1.2em] font-[700] px-8 max-[645px]:px-1 "
                            style={{ fontFamily: "Work Sans" }}
                          >
                            ELABORATE
                          </p>
                        </button>
                      </Tooltip>
                      <Tooltip title={"Research"} arrow placement="left">
                        <button
                          style={{
                            backgroundColor: tab === 2 ? "#428CFB" : "#EFEFFD",
                            color: tab === 2 ? "white" : "#428CFB",
                            padding: "2em",
                          }}
                          className="border border-transparent rounded-lg  flex flex-row justify-center items-center space-x-2 py-2  w-full"
                          onClick={() => {
                            setTab(2);
                            setlistvisible(false);
                            setshowsearch(false);
                            setshowchatwithpdf(false);
                            setIsOptionsVisible(false);
                          }}
                        >
                          <p
                            className="text-[1.2em] font-[700] px-8 max-[645px]:px-1 "
                            style={{ fontFamily: "Work Sans" }}
                          >
                            RESEARCH
                          </p>
                        </button>
                      </Tooltip>
                      <Tooltip title="Chat with pdf" arrow placement="left">
                        <button
                          style={{
                            backgroundColor: tab === 3 ? "#428CFB" : "#EFEFFD",
                            color: tab === 3 ? "white" : "#428CFB",
                            padding: "2em",
                          }}
                          className=" border border-transparent  rounded-lg  flex flex-row justify-center items-center space-x-2 py-2  w-full"
                          onClick={() => {
                            setTab(3);
                            handleClientLoad();
                            setshowsearch(true);
                            setlistvisible(false);
                            setshowchatwithpdf(false);
                            setIsOptionsVisible(false);
                          }}
                        >
                          <div className="flex flex-row">
                            <p
                              className=" text-[1.2em] font-[700] pl-1 px-1 max-[645px]:px-1  "
                              style={{ fontFamily: "Work Sans" }}
                            >
                              CHAT
                            </p>
                            <p
                              className=" text-[1.2em] font-[700] "
                              style={{ fontFamily: "Work Sans" }}
                            >
                              WITH
                            </p>
                            <p
                              className=" text-[1.2em] font-[700] px-1 pr-1 max-[645px]:px-1"
                              style={{ fontFamily: "Work Sans" }}
                            >
                              PDF
                            </p>
                          </div>
                        </button>
                      </Tooltip>
                    </div>
                  </div>
                ) : (
                  <>
                    {sty === "true" ? (
                      <ListItem className="pulse flex flex-col  lg:flex-row justify-around items-center gap-5  lg:!w-full lg:!px-0">
                        {listvisible && (
                          <>
                            <FormControl
                              className="lg:!flex flex-col gap-1  w-[120px]"
                              fullWidth
                            >
                              <InputLabel
                                id="demo-simple-select-helper-label"
                                fullWidth
                              >
                                Writing Style
                              </InputLabel>
                              <Tooltip
                                open={sty === "true"}
                                placement="top"
                                arrow
                                title={
                                  <div className=" rounded-lg">
                                    <p
                                      className=" text-white text-base max-[1050px]:text-xs"
                                      style={{ fontFamily: "Work Sans" }}
                                    >
                                      You can choose from a variety of writing
                                      styles, tones, and languages! Why don’t
                                      you paste your research information here
                                      and give it a try?
                                    </p>
                                  </div>
                                }
                                componentsProps={{
                                  tooltip: {
                                    sx: {
                                      bgcolor: "#0E0E2C",
                                      "& .MuiTooltip-arrow": {
                                        color: "#0E0E2C",
                                      },
                                    },
                                  },
                                }}
                              >
                                <Select
                                  labelId="demo-simple-select-helper-label"
                                  id="demo-simple-select-helper"
                                  className="!h-[3] !w-full !rounded-lg"
                                  value={style}
                                  label="Writing Style"
                                  onChange={(e) => {
                                    setStyle(e.target.value);
                                    setsty("false");
                                    setel("true");
                                  }}
                                >
                                  <MenuItem value={"Poetic"}>Poetic</MenuItem>
                                  <FormControl
                                    className="lg:!flex flex-col gap-1  w-[120px]"
                                    fullWidth
                                  >
                                    <InputLabel
                                      id="demo-simple-select-helper-label"
                                      fullWidth
                                    ></InputLabel>
                                    Writing Style
                                    <MenuItem
                                      value={"Writing Style"}
                                    ></MenuItem>
                                  </FormControl>
                                  <MenuItem value={"Stand-up Comedian"}>
                                    Stand-up Comedian
                                  </MenuItem>
                                  <MenuItem value={"Motivational Coach"}>
                                    Motivational Coach
                                  </MenuItem>
                                  <MenuItem value={"Relationship Coach"}>
                                    Relationship Coach
                                  </MenuItem>
                                  <MenuItem value={"Philosopher"}>
                                    Philosopher
                                  </MenuItem>
                                  <MenuItem value={"Astrologer"}>
                                    Astrologer
                                  </MenuItem>
                                  <MenuItem value={"Career Counselor"}>
                                    Career Counselor
                                  </MenuItem>
                                  <MenuItem value={"Personal Trainer"}>
                                    Personal Trainer
                                  </MenuItem>
                                  <MenuItem value={"Accountant"}>
                                    Accountant
                                  </MenuItem>
                                </Select>
                              </Tooltip>
                            </FormControl>
                            <FormControl
                              className="flex flex-col gap-1  w-[120px]"
                              fullWidth
                            >
                              <InputLabel id="demo-simple-select-helper-label">
                                Tone
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-helper-label"
                                id="demo-simple-select-helper"
                                className="!h-[3]"
                                value={tone}
                                label="Tone"
                                onChange={(e) => setTone(e.target.value)}
                              >
                                <MenuItem value={"Professional"}>
                                  Professional{" "}
                                </MenuItem>
                                <MenuItem value={"Emmotional"}>
                                  Emotional{" "}
                                </MenuItem>
                                <MenuItem value={"Encouraging"}>
                                  Encouraging{" "}
                                </MenuItem>
                                <MenuItem value={"Creative"}>
                                  Creative{" "}
                                </MenuItem>
                                <MenuItem value={"Funny"}>Funny </MenuItem>
                                <MenuItem value={"Dramatic"}>
                                  Dramatic{" "}
                                </MenuItem>
                                <MenuItem value={"Witty"}>Witty </MenuItem>
                                <MenuItem value={"Sarcastic"}>
                                  Sarcastic{" "}
                                </MenuItem>
                                <MenuItem value={"Engaging"}>
                                  Engaging{" "}
                                </MenuItem>
                              </Select>
                            </FormControl>
                            <FormControl
                              className="flex flex-col gap-1  w-[120px]"
                              fullWidth
                            >
                              <InputLabel id="demo-simple-select-helper-label">
                                Output In
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-helper-label"
                                id="demo-simple-select-helper"
                                className="!h-[3]"
                                value={language}
                                label="Output In"
                                onChange={(e) => setLanguage(e.target.value)}
                              >
                                <MenuItem value={"en"}>English </MenuItem>
                                <MenuItem value={"hindi"}>Hindi</MenuItem>
                                <MenuItem value={"kn"}>Kannada</MenuItem>
                                <MenuItem value={"fr"}>French </MenuItem>
                                <MenuItem value={"ja"}>Japanese</MenuItem>
                                <MenuItem value={"ar"}>Arabic</MenuItem>
                                <MenuItem value={"bn"}>Bangla</MenuItem>
                              </Select>
                            </FormControl>
                          </>
                        )}
                        {showsearch && (
                          <>
                            <div className="flex flex-row w-100 mx-auto ">
                              <input
                                className="shadow appearance-none border rounded w-100 bg-red-200 py-1 px-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                id="username"
                                placeholder="Title"
                                type="text"
                                value={searchTerm}
                                onChange={(e) => {
                                  if (e.target.value) {
                                    setSearchTerm(e.target.value);
                                  } else {
                                    setSearchTerm(e.target.value);
                                    handleClientLoad();
                                  }
                                }}
                              />
                              <button
                                className="h-[30px] flex flex-row justify-center items-center bg-blue-500 px-4 gap-2 rounded-[8px] hover:bg-blue-700 text-[16px] border-2 font-[700] leading-[19px] text-[#f9f9f9] outline-none
focus:outline-4 focus:outline-[#31D0AA] "
                                onClick={() => search1()}
                              >
                                <Search color="light" />
                              </button>
                            </div>
                          </>
                        )}
                        {showchatwithpdf && (
                          <>
                            <div className="flex flex-row justify-between items-center w-full gap-3 ">
                              <button
                                className="h-[43px] flex flex-row justify-center items-center bg-blue-500 px-4 gap-2 rounded-[8px] hover:bg-blue-700 text-[16px] border-2 font-[700] leading-[19px] text-[#f9f9f9] outline-none
  focus:outline-4 focus:outline-[#31D0AA] mb-2"
                                onClick={() => {
                                  setshowchatwithpdf(false);
                                  setshowsearch(true);
                                }}
                              >
                                Return
                              </button>
                            </div>
                          </>
                        )}
                      </ListItem>
                    ) : (
                      <ListItem className=" flex flex-col lg:flex-row justify-around items-center gap-5 lg:!w-full lg:!px-0">
                        {listvisible && (
                          <>
                            <FormControl
                              className="lg:!flex flex-col gap-1  w-[120px]"
                              fullWidth
                            >
                              <InputLabel
                                id="demo-simple-select-helper-label"
                                fullWidth
                              >
                                Writing Style
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-helper-label"
                                id="demo-simple-select-helper"
                                className="!h-[3] !w-full !rounded-lg"
                                value={style}
                                label="Writing Style"
                                onChange={(e) => setStyle(e.target.value)}
                              >
                                <MenuItem value={"Default"}>Default</MenuItem>
                                <MenuItem value={"Academic"}>Academic</MenuItem>
                                <MenuItem value={"Analytical"}>
                                  Analytical
                                </MenuItem>
                                <MenuItem value={"Argumentative"}>
                                  Argumentative
                                </MenuItem>
                                <MenuItem value={"Conversational"}>
                                  Conversational
                                </MenuItem>
                                <MenuItem value={"Creative"}>Creative</MenuItem>
                                <MenuItem value={"Critical"}>Critical</MenuItem>
                                <MenuItem value={"Descriptive"}>
                                  Descriptive
                                </MenuItem>
                                <MenuItem value={"Epigrammatic"}>
                                  Epigrammatic
                                </MenuItem>
                                <MenuItem value={"Epistolary"}>
                                  Epistolary
                                </MenuItem>
                                <MenuItem value={"Expository"}>
                                  Expository
                                </MenuItem>
                                <MenuItem value={"Informative"}>
                                  Informative
                                </MenuItem>
                                <MenuItem value={"Instructive"}>
                                  Instructive
                                </MenuItem>
                                <MenuItem value={"Journalistic"}>
                                  Journalistic
                                </MenuItem>
                                <MenuItem value={"Metaphorical"}>
                                  Metaphorical
                                </MenuItem>
                                <MenuItem value={"Narrative"}>
                                  Narrative
                                </MenuItem>
                                <MenuItem value={"Persuasive"}>
                                  Persuasive
                                </MenuItem>
                                <MenuItem value={"Poetic"}>Poetic</MenuItem>
                                <MenuItem value={"Satirical"}>
                                  Satirical
                                </MenuItem>
                                <MenuItem value={"Technical"}>
                                  Technical
                                </MenuItem>
                              </Select>
                            </FormControl>
                            <FormControl
                              className="flex flex-col gap-1  w-[120px]"
                              fullWidth
                            >
                              <InputLabel id="demo-simple-select-helper-label">
                                Tone
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-helper-label"
                                id="demo-simple-select-helper"
                                className="!h-[3]"
                                value={tone}
                                label="Tone"
                                onChange={(e) => setTone(e.target.value)}
                              >
                                <MenuItem value={"Professional"}>
                                  Professional{" "}
                                </MenuItem>
                                <MenuItem value={"Emmotional"}>
                                  Emotional{" "}
                                </MenuItem>
                                <MenuItem value={"Encouraging"}>
                                  Encouraging{" "}
                                </MenuItem>
                                <MenuItem value={"Creative"}>
                                  Creative{" "}
                                </MenuItem>
                                <MenuItem value={"Funny"}>Funny </MenuItem>
                                <MenuItem value={"Dramatic"}>
                                  Dramatic{" "}
                                </MenuItem>
                                <MenuItem value={"Witty"}>Witty </MenuItem>
                                <MenuItem value={"Sarcastic"}>
                                  Sarcastic{" "}
                                </MenuItem>
                                <MenuItem value={"Engaging"}>
                                  Engaging{" "}
                                </MenuItem>
                              </Select>
                            </FormControl>
                            <FormControl
                              className="flex flex-col gap-1  w-[120px]"
                              fullWidth
                            >
                              <InputLabel id="demo-simple-select-helper-label">
                                Output In
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-helper-label"
                                id="demo-simple-select-helper"
                                className="!h-[3]"
                                value={language}
                                label="Output In"
                                onChange={(e) => setLanguage(e.target.value)}
                              >
                                <MenuItem value={"en"}>English </MenuItem>
                                <MenuItem value={"hindi"}>Hindi</MenuItem>
                                <MenuItem value={"kn"}>Kannada</MenuItem>
                                <MenuItem value={"fr"}>French </MenuItem>
                                <MenuItem value={"ja"}>Japanese</MenuItem>
                                <MenuItem value={"ar"}>Arabic</MenuItem>
                                <MenuItem value={"bn"}>Bangla</MenuItem>
                              </Select>
                            </FormControl>
                          </>
                        )}
                        {showsearch && (
                          <>
                            <div className="flex flex-row justify-between items-center w-full gap-3 ">
                              <input
                                className=" bg-blue-50 rounded-lg outline-none focus:outline-4 focus:outline-blue-400 border-blue-400 h-[40px] text-center w-full scrollbar-hide"
                                rows={2}
                                value={searchTerm}
                                onChange={(e) => {
                                  if (e.target.value) {
                                    setSearchTerm(e.target.value);
                                  } else {
                                    setSearchTerm(e.target.value);
                                    handleClientLoad();
                                  }
                                }}
                                // onKeyDown={(e) => e.key === "Enter" && research()}
                                placeholder="Write Text Here"
                              />
                              <button
                                className="h-[43px] flex flex-row justify-center items-center bg-blue-500 px-4 gap-2 rounded-[8px] hover:bg-blue-700 text-[16px] border-2 font-[700] leading-[19px] text-[#f9f9f9] outline-none
  focus:outline-4 focus:outline-[#31D0AA] mb-2"
                                onClick={() => {
                                  search1();
                                }}
                              >
                                <Search color="light" />
                              </button>
                            </div>
                          </>
                        )}
                        {showchatwithpdf && (
                          <>
                            <div className="flex flex-row justify-between items-center w-full gap-3 ">
                              <button
                                className="h-[43px] flex flex-row justify-center items-center bg-blue-500 px-4 gap-2 rounded-[8px] hover:bg-blue-700 text-[16px] border-2 font-[700] leading-[19px] text-[#f9f9f9] outline-none
  focus:outline-4 focus:outline-[#31D0AA] mb-2"
                                onClick={() => {
                                  setshowchatwithpdf(false);
                                  setshowsearch(true);
                                }}
                              >
                                Return
                              </button>
                            </div>
                          </>
                        )}
                      </ListItem>
                    )}
                    <div className="w-full m-auto flex flex-col mx-1  justify-center items-center">
                      {tab === 0 && (
                        <>
                          <textarea
                            className="bg-blue-50 rounded-lg outline-none focus:outline-4 focus:outline-blue-400 border-blue-400 h-[370px] text-center pt-5 mb-1 !pl-1 lg:w-[100%] scrollbar-hide"
                            rows={2}
                            value={SummeriseText}
                            onChange={(e) => setSummeriseText(e.target.value)}
                            placeholder="Enter Text Here"
                          />
                          <button
                            className="h-[48px] w-[100%] flex flex-row bg-blue-500 justify-center items-center  rounded-[8px] hover:bg-blue-700 text-[16px] border-2 font-[700] leading-[19px] text-[#ffffff] outline-none
  focus:outline-4 focus:outline-[#31D0AA] mt-1"
                            onClick={() => {
                              summarise(SummeriseText);
                              setSideMenu(false);
                            }}
                          >
                            SUMMARISE
                          </button>
                        </>
                      )}
                      {tab === 1 && (
                        <>
                          <textarea
                            className="bg-blue-50 rounded-lg outline-none focus:outline-4 focus:outline-blue-400 border-blue-400 h-[370px] text-center mb-1 w-full max-w-[26rem] lg:max-w-full lg:w-[100%] scrollbar-hide"
                            rows={2}
                            value={ElaborateText}
                            onChange={(e) => setElaborateText(e.target.value)}
                            placeholder="Enter Text Here"
                          />

                          <button
                            className="h-[48px] w-[100%] flex flex-row justify-center bg-blue-500 items-center px-4 gap-2 rounded-[8px] hover:bg-blue-700 text-[16px] border-2 font-[700] leading-[19px] text-[#ffffff] outline-none
  focus:outline-4 focus:outline-[#31D0AA] mt-1"
                            onClick={() => {
                              elaborate(ElaborateText);
                              // checking(ElaborateText);
                              setSideMenu(false);
                            }}
                          >
                            ELABORATE
                          </button>
                        </>
                      )}
                      {tab === 3 && (
                        <>
                          <div className="m-1 h-[420px] overflow-y-scroll scrollbar-hide w-[96%]">
                            <>
                              {!showchatwithpdf ? (
                                !showfolder ? (
                                  <div>
                                    <div className="m-3 ">
                                      <input
                                        type="file"
                                        onChange={(e) => {
                                          if (e.target.files[0]) {
                                            setlocalfile(e.target.files[0]);
                                          }
                                        }}
                                      />
                                      <Button
                                        variant="contained"
                                        onClick={() => {
                                          uploadlocalfile();
                                        }}
                                      >
                                        Upload
                                      </Button>
                                    </div>
                                    <table className="min-w-full">
                                      <thead>
                                        <tr className="flex flex-row  items-center"></tr>
                                      </thead>
                                      <tbody className="">
                                        {documents.map((item, index) => (
                                          <div
                                            key={index}
                                            className="group relative"
                                          >
                                            {item.mimeType.slice(
                                              item.mimeType.length - 6,
                                              item.mimeType.length
                                            ) === "folder" ? (
                                              <div>
                                                <div
                                                  className="mt-4 flex justify-between cursor-pointer  bg-white hover:bg-[#EFEFFD] p-3 rounded-lg drop-shadow-md w-[99%]"
                                                  onClick={() =>
                                                    filesfromfolder(item.id)
                                                  }
                                                >
                                                  <div className="flex flex-row gap-8">
                                                    {show1 ? (
                                                      <FolderIcon fontSize="large" />
                                                    ) : (
                                                      <FolderIcon fontSize="large" />
                                                    )}
                                                    <p
                                                      className="mt-1 mr-5 text-base text-black "
                                                      style={{
                                                        fontFamily: "Work Sans",
                                                      }}
                                                    >
                                                      {item.title}
                                                    </p>
                                                  </div>
                                                </div>
                                              </div>
                                            ) : null}
                                          </div>
                                        ))}
                                        {documents.map((item, index) => (
                                          <div
                                            key={index}
                                            className="group relative"
                                          >
                                            {item.mimeType.slice(
                                              item.mimeType.length - 6,
                                              item.mimeType.length
                                            ) === "folder" ? null : (
                                              <div
                                                className="mt-4 flex justify-between  bg-white hover:bg-[#EFEFFD] p-3 rounded-lg drop-shadow-md cursor-pointer w-[99%]"
                                                onClick={() =>
                                                  getfile1(item.id)
                                                }
                                              >
                                                <div className="flex flex-row gap-8">
                                                  <p
                                                    className="mt-1 mr-5 text-base text-black"
                                                    style={{
                                                      fontFamily: "Work Sans",
                                                    }}
                                                  >
                                                    {item.title}
                                                  </p>
                                                </div>
                                              </div>
                                            )}
                                          </div>
                                        ))}
                                      </tbody>
                                    </table>
                                  </div>
                                ) : (
                                  <div>
                                    {show1 &&
                                      (length1 === 0 ? (
                                        <div>
                                          <button
                                            className="h-[43px] flex flex-row justify-center items-center bg-blue-500 px-4 gap-2 rounded-[8px] hover:bg-blue-700 text-[16px] border-2 font-[700] leading-[19px] text-[#f9f9f9] outline-none
  focus:outline-4 focus:outline-[#31D0AA] mb-2"
                                            onClick={() => {
                                              setshowfolder(false);
                                            }}
                                          >
                                            Return
                                          </button>
                                          <p>No data to show</p>{" "}
                                        </div>
                                      ) : (
                                        <>
                                          <button
                                            className="h-[43px] flex flex-row justify-center items-center bg-blue-500 px-4 gap-2 rounded-[8px] hover:bg-blue-700 text-[16px] border-2 font-[700] leading-[19px] text-[#f9f9f9] outline-none
  focus:outline-4 focus:outline-[#31D0AA] mb-2"
                                            onClick={() => {
                                              setshowfolder(false);
                                            }}
                                          >
                                            Return
                                          </button>
                                          {foldersdata.map((item, index) => (
                                            <div
                                              key={index}
                                              className="group relative"
                                            >
                                              {
                                                <div
                                                  className="mt-4 ml-16 flex bg-white hover:bg-[#EFEFFD] p-3 rounded-lg drop-shadow-md cursor-pointer w-[99%]"
                                                  onClick={() => {
                                                    uploadgd(
                                                      item.alternateLink,
                                                      item.title,
                                                      user.id
                                                    );
                                                    setshowchatwithpdf(true);
                                                    setshowsearch(false);
                                                  }}
                                                >
                                                  <div className="flex flex-row gap-8">
                                                    <p
                                                      className="mt-1 mr-5 text-base text-black"
                                                      style={{
                                                        fontFamily: "Work Sans",
                                                      }}
                                                    >
                                                      {item.title}
                                                    </p>
                                                  </div>
                                                </div>
                                              }
                                            </div>
                                          ))}
                                        </>
                                      ))}
                                  </div>
                                )
                              ) : (
                                <div>
                                  <div
                                    id="messages"
                                    style={{ fontFamily: "Work Sans" }}
                                    className="flex flex-col p-3  overflow-y-scroll  scrollbar-thumb-rounded scrollbar-track-blue-lighter scrollbar-w-2 scrolling-touch messages scrollbar-hide"
                                  >
                                    {displayMessages &&
                                      displayMessages.map((msg, i) => (
                                        <Fade bottom>
                                          <div
                                            className="chat-message py-2"
                                            key={i}
                                          >
                                            <div
                                              className={`flex items-end ${
                                                msg[1] === "sent" &&
                                                "justify-end"
                                              }`}
                                            >
                                              <div className="flex flex-col space-y-2 text-md max-w-lg mx-2 order-2 items-end">
                                                <div>
                                                  <span
                                                    className={`px-4 py-2 rounded-lg inline-block rounded-bl-none ${
                                                      msg[1] === "sent"
                                                        ? "bg-[#428CFB] text-white"
                                                        : "bg-gray-300 text-gray-600"
                                                    }`}
                                                  >
                                                    {msg[0]}
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </Fade>
                                      ))}
                                    <div id="bottomRef" ref={bottomRef} />
                                  </div>
                                  <div className="px-4 mb-2">
                                    <div className="relative pt-4 flex justify-between items-center w-full">
                                      <input
                                        type="text"
                                        placeholder="Write your message!"
                                        value={msg}
                                        rows={1}
                                        onChange={(e) => setMsg(e.target.value)}
                                        onKeyDown={(e) => {
                                          if (e.shiftKey && e.code === 13)
                                            setMsg(msg + "\n");
                                          else if (
                                            e.key === "Enter" &&
                                            !input &&
                                            !e.shiftKey
                                          )
                                            getChat();
                                        }}
                                        className="lg:w-[80%] focus:outline-none focus:placeholder-gray-400 text-gray-600 placeholder-gray-600 pl-2 bg-gray-200 rounded-md py-3 scrollbar-hide w-full mr-2"
                                      />
                                      <div className=" right-0 items-center inset-y-0 sm:flex">
                                        <button
                                          disabled={input}
                                          type="button"
                                          className="inline-flex items-center justify-center rounded-lg px-4 py-3 transition duration-500 ease-in-out text-white bg-[#428CFB] hover:bg-[#428CFB] focus:outline-none"
                                          onClick={() => getChat()}
                                        >
                                          <span className="font-bold">
                                            Send
                                          </span>
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 20 20"
                                            fill="currentColor"
                                            className="h-6 w-6 ml-2 transform rotate-90"
                                          >
                                            <path d="M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z"></path>
                                          </svg>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </>
                          </div>
                        </>
                      )}
                      {tab === 2 && (
                        <>
                          <div className="flex flex-row justify-between items-center w-[90%] max-w-[550px] gap-3">
                            <>
                              {re2 === "true" ? (
                                <Tooltip
                                  open={re2 === "true"}
                                  placement="bottom"
                                  arrow
                                  title={
                                    <div className="rounded-lg">
                                      <p
                                        className="text-white text-base max-[750px]:text-xs"
                                        style={{ fontFamily: "Work Sans" }}
                                      >
                                        Let's “Research”! Type the Cornell
                                        method of note-taking. You can type in
                                        any question or topic you’d like to
                                        learn more about
                                      </p>
                                    </div>
                                  }
                                  componentsProps={{
                                    tooltip: {
                                      sx: {
                                        bgcolor: "#0E0E2C",
                                        "& .MuiTooltip-arrow": {
                                          color: "#0E0E2C",
                                        },
                                      },
                                    },
                                  }}
                                >
                                  <input
                                    className="pulse flex justify-between items-center bg-blue-50 rounded-lg outline-none focus:outline-4 focus:outline-blue-400 border-blue-400 h-[40px] text-center w-full scrollbar-hide"
                                    rows={2}
                                    value={researchText}
                                    onChange={(e) => {
                                      setResearchText(e.target.value);
                                      setre2("false");
                                      setai1("true");
                                    }}
                                    onKeyDown={(e) =>
                                      e.key === "Enter" && research()
                                    }
                                    placeholder="Write Text Here"
                                  />
                                </Tooltip>
                              ) : (
                                <div className="bg-blue-50 flex justify-between items-center rounded-lg outline-none outline-2 outline-blue-400 text-center w-[90%] scrollbar-hide">
                                  <input
                                    className="bg-transparent w-full text-center outline-none"
                                    rows={2}
                                    value={researchText}
                                    onChange={(e) =>
                                      setResearchText(e.target.value)
                                    }
                                    onKeyDown={(e) =>
                                      e.key === "Enter" && research()
                                    }
                                    placeholder="Write Text Here"
                                  />
                                  <div className="flex items-center justify-center">
                                    <span className="hidden lg:block">
                                      {academic ? "Academic" : "Web Search"}{" "}
                                    </span>
                                    <Switch
                                      checked={academic}
                                      onChange={() => setAcademic(!academic)}
                                    />
                                  </div>
                                </div>
                              )}
                            </>
                            <button
                              className="h-[42px] flex flex-row justify-center items-center bg-blue-500 px-4 gap-2 rounded-[8px] hover:bg-blue-700 text-[16px] border-2 font-[700] leading-[19px] text-[#f9f9f9] outline-none focus:outline-4 focus:outline-[#31D0AA]"
                              onClick={() => {
                                research();
                              }}
                            >
                              <TravelExplore color="light" />
                            </button>
                          </div>
                          {!showLoadMore && loading && <Loading />}
                          {researchResponse?.length >= 1 &&
                            researchResponse.map(
                              (card) =>
                                card && (
                                  <div
                                    className="m-auto w-[90%]"
                                    key={card.paperId}
                                  >
                                    <ResearchCard
                                      handleCitations={handleCitations}
                                      getIndex={getIndex}
                                      caption={caption}
                                      headCaption={headCaption}
                                      titleObject={titleObject}
                                      notes={notes}
                                      isBookmarked={isBookmarked}
                                      setLoading={setLoading}
                                      data={card}
                                      setSideMenu={setSideMenu}
                                      editor={ref}
                                      onViewInNewTab={() =>
                                        handleView(card.url)
                                      }
                                      onsetBookmark={() =>
                                        setBookmark(
                                          user.id,
                                          card.title,
                                          card.paperId,
                                          card.url
                                        )
                                      }
                                    />
                                  </div>
                                )
                            )}
                          {!academic && <WIkiCard data={researchResponse} />}
                          {loading && showLoadMore && <Loading />}
                          {academic && showLoadMore && (
                            <button
                              className="bg-blue-500 px-4 py-2 text-white rounded mt-4"
                              onClick={() => research(true)}
                            >
                              Load More
                            </button>
                          )}
                        </>
                      )}
                    </div>
                  </>
                )}
              </div>
            ) : (
              <div className="flex lg:flex-row justify-between items-start w-full mt-1">
                <div
                  className="container px-5  mx-auto"
                  style={{ fontFamily: "Work Sans" }}
                >
                  <div className="flex flex-col text-center w-[80%] mb-2">
                    <div className="flex mx-auto  bg-[#EFEFFD] rounded-lg overflow-hidden">
                      <Tooltip title={"Summarise"} arrow placement="bottom">
                        <Button
                          style={{
                            backgroundColor: tab === 0 ? "#428CFB" : "#EFEFFD",
                            color: tab === 0 ? "white" : "#428CFB",
                          }}
                          className="border border-transparent rounded-lg  flex flex-row justify-center items-center space-x-2 py-2  w-full"
                          onClick={() => {
                            setTab(0);
                            setlistvisible(true);
                            setshowsearch(false);
                            setshowchatwithpdf(false);
                          }}
                        >
                          <p
                            className=" text-[16px] font-[700] px-2 max-[645px]:px-1 max-[645px]:text-[8px]"
                            style={{ fontFamily: "Work Sans" }}
                          >
                            Summarise
                          </p>
                        </Button>
                      </Tooltip>
                      <Tooltip title={"Elaborate"} arrow placement="bottom">
                        <button
                          style={{
                            backgroundColor: tab === 1 ? "#428CFB" : "#EFEFFD",
                            color: tab === 1 ? "white" : "#428CFB",
                          }}
                          className="border border-transparent rounded-lg  flex flex-row justify-center items-center space-x-2 py-2  w-full"
                          onClick={() => {
                            setTab(1);
                            setlistvisible(true);
                            setshowsearch(false);
                            setshowchatwithpdf(false);
                          }}
                        >
                          <p
                            className=" text-[16px] font-[700] px-2 max-[645px]:px-1 max-[645px]:text-[8px]"
                            style={{ fontFamily: "Work Sans" }}
                          >
                            ELABORATE
                          </p>
                        </button>
                      </Tooltip>
                      <Tooltip title={"Research"} arrow placement="bottom">
                        <button
                          style={{
                            backgroundColor: tab === 2 ? "#428CFB" : "#EFEFFD",
                            color: tab === 2 ? "white" : "#428CFB",
                          }}
                          className="border border-transparent rounded-lg  flex flex-row justify-center items-center space-x-2 py-2  w-full"
                          onClick={() => {
                            setTab(2);
                            setlistvisible(false);
                            setshowsearch(false);
                            setshowchatwithpdf(false);
                          }}
                        >
                          <p
                            className="text-[16px] font-[700] px-8 max-[645px]:px-1 max-[645px]:text-[8px]"
                            style={{ fontFamily: "Work Sans" }}
                          >
                            RESEARCH
                          </p>
                        </button>
                      </Tooltip>
                      <Tooltip title="Chat with pdf" arrow placement="bottom">
                        <button
                          style={{
                            backgroundColor: tab === 3 ? "#428CFB" : "#EFEFFD",
                            color: tab === 3 ? "white" : "#428CFB",
                          }}
                          className=" border border-transparent  rounded-lg  flex flex-row justify-center items-center space-x-2 py-2  w-full"
                          onClick={() => {
                            setTab(3);
                            handleClientLoad();
                            setshowsearch(true);
                            setlistvisible(false);
                            setshowchatwithpdf(false);
                          }}
                        >
                          <div className="flex flex-row">
                            <p
                              className=" text-[16px] font-[700] pl-1 px-1 max-[645px]:px-1  max-[645px]:text-[8px]"
                              style={{ fontFamily: "Work Sans" }}
                            >
                              CHAT
                            </p>
                            <p
                              className=" text-[16px] font-[700] max-[645px]:text-[8px]"
                              style={{ fontFamily: "Work Sans" }}
                            >
                              WITH
                            </p>
                            <p
                              className=" text-[16px] font-[700] px-1 pr-1 max-[645px]:px-1 max-[645px]:text-[8px]"
                              style={{ fontFamily: "Work Sans" }}
                            >
                              PDF
                            </p>
                          </div>
                        </button>
                      </Tooltip>
                    </div>
                  </div>
                  <>
                    {sty === "true" ? (
                      <ListItem className="pulse flex flex-col lg:flex-row justify-around items-center gap-5 lg:!w-full lg:!px-0">
                        {listvisible ? (
                          <>
                            <FormControl
                              className="lg:!flex flex-col gap-1  w-[120px]"
                              fullWidth
                            >
                              <InputLabel
                                id="demo-simple-select-helper-label"
                                fullWidth
                              >
                                Writing Style
                              </InputLabel>
                              <Tooltip
                                open={sty === "true"}
                                placement="top"
                                arrow
                                title={
                                  <div className=" rounded-lg">
                                    <p
                                      className=" text-white text-base max-[1050px]:text-xs"
                                      style={{ fontFamily: "Work Sans" }}
                                    >
                                      You can choose from a variety of writing
                                      styles, tones, and languages! Why don’t
                                      you paste your research information here
                                      and give it a try?
                                    </p>
                                  </div>
                                }
                                componentsProps={{
                                  tooltip: {
                                    sx: {
                                      bgcolor: "#0E0E2C",
                                      "& .MuiTooltip-arrow": {
                                        color: "#0E0E2C",
                                      },
                                    },
                                  },
                                }}
                              >
                                <Select
                                  labelId="demo-simple-select-helper-label"
                                  id="demo-simple-select-helper"
                                  className="!h-[3] !w-full !rounded-lg"
                                  value={style}
                                  label="Writing Style"
                                  onChange={(e) => {
                                    setStyle(e.target.value);
                                    setsty("false");
                                    setel("true");
                                  }}
                                >
                                  <MenuItem value={"Poetic"}>Poetic</MenuItem>
                                  <FormControl
                                    className="lg:!flex flex-col gap-1  w-[120px]"
                                    fullWidth
                                  >
                                    <InputLabel
                                      id="demo-simple-select-helper-label"
                                      fullWidth
                                    ></InputLabel>
                                    Writing Style
                                    <MenuItem
                                      value={"Writing Style"}
                                    ></MenuItem>
                                  </FormControl>
                                  <MenuItem value={"Stand-up Comedian"}>
                                    Stand-up Comedian
                                  </MenuItem>
                                  <MenuItem value={"Motivational Coach"}>
                                    Motivational Coach
                                  </MenuItem>
                                  <MenuItem value={"Relationship Coach"}>
                                    Relationship Coach
                                  </MenuItem>
                                  <MenuItem value={"Philosopher"}>
                                    Philosopher
                                  </MenuItem>
                                  <MenuItem value={"Astrologer"}>
                                    Astrologer
                                  </MenuItem>
                                  <MenuItem value={"Career Counselor"}>
                                    Career Counselor
                                  </MenuItem>
                                  <MenuItem value={"Personal Trainer"}>
                                    Personal Trainer
                                  </MenuItem>
                                  <MenuItem value={"Accountant"}>
                                    Accountant
                                  </MenuItem>
                                </Select>
                              </Tooltip>
                            </FormControl>
                            <FormControl
                              className="flex flex-col gap-1  w-[120px]"
                              fullWidth
                            >
                              <InputLabel id="demo-simple-select-helper-label">
                                Tone
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-helper-label"
                                id="demo-simple-select-helper"
                                className="!h-[3]"
                                value={tone}
                                label="Tone"
                                onChange={(e) => setTone(e.target.value)}
                              >
                                <MenuItem value={"Professional"}>
                                  Professional{" "}
                                </MenuItem>
                                <MenuItem value={"Emmotional"}>
                                  Emotional{" "}
                                </MenuItem>
                                <MenuItem value={"Encouraging"}>
                                  Encouraging{" "}
                                </MenuItem>
                                <MenuItem value={"Creative"}>
                                  Creative{" "}
                                </MenuItem>
                                <MenuItem value={"Funny"}>Funny </MenuItem>
                                <MenuItem value={"Dramatic"}>
                                  Dramatic{" "}
                                </MenuItem>
                                <MenuItem value={"Witty"}>Witty </MenuItem>
                                <MenuItem value={"Sarcastic"}>
                                  Sarcastic{" "}
                                </MenuItem>
                                <MenuItem value={"Engaging"}>
                                  Engaging{" "}
                                </MenuItem>
                              </Select>
                            </FormControl>
                            <FormControl
                              className="flex flex-col gap-1  w-[120px]"
                              fullWidth
                            >
                              <InputLabel id="demo-simple-select-helper-label">
                                Output In
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-helper-label"
                                id="demo-simple-select-helper"
                                className="!h-[3]"
                                value={language}
                                label="Output In"
                                onChange={(e) => setLanguage(e.target.value)}
                              >
                                <MenuItem value={"en"}>English </MenuItem>
                                <MenuItem value={"hindi"}>Hindi</MenuItem>
                                <MenuItem value={"kn"}>Kannada</MenuItem>
                                <MenuItem value={"fr"}>French </MenuItem>
                                <MenuItem value={"ja"}>Japanese</MenuItem>
                                <MenuItem value={"ar"}>Arabic</MenuItem>
                                <MenuItem value={"bn"}>Bangla</MenuItem>
                              </Select>
                            </FormControl>
                          </>
                        ) : (
                          <h1 className="hidden">hidden</h1>
                        )}
                        {showsearch && (
                          <>
                            <div className="flex flex-row w-100 mx-auto ">
                              <input
                                className="shadow appearance-none border rounded w-100 bg-red-200 py-1 px-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                id="username"
                                placeholder="Title"
                                type="text"
                                value={searchTerm}
                                onChange={(e) => {
                                  if (e.target.value) {
                                    setSearchTerm(e.target.value);
                                  } else {
                                    setSearchTerm(e.target.value);
                                    handleClientLoad();
                                  }
                                }}
                              />
                              <button
                                className="h-[30px] flex flex-row justify-center items-center bg-blue-500 px-4 gap-2 rounded-[8px] hover:bg-blue-700 text-[16px] border-2 font-[700] leading-[19px] text-[#f9f9f9] outline-none
focus:outline-4 focus:outline-[#31D0AA] "
                                onClick={() => search1()}
                              >
                                <Search color="light" />
                              </button>
                            </div>
                          </>
                        )}
                        {showchatwithpdf && (
                          <>
                            <div className="flex flex-row justify-between items-center w-full gap-3 ">
                              <button
                                className="h-[43px] flex flex-row justify-center items-center bg-blue-500 px-4 gap-2 rounded-[8px] hover:bg-blue-700 text-[16px] border-2 font-[700] leading-[19px] text-[#f9f9f9] outline-none
  focus:outline-4 focus:outline-[#31D0AA] mb-2"
                                onClick={() => {
                                  setshowchatwithpdf(false);
                                  setshowsearch(true);
                                }}
                              >
                                Return
                              </button>
                            </div>
                          </>
                        )}
                      </ListItem>
                    ) : (
                      <ListItem className=" flex flex-col lg:flex-row justify-around items-center gap-5 lg:!w-full lg:!px-0">
                        {listvisible && (
                          <>
                            <FormControl
                              className="lg:!flex flex-col gap-1  w-[120px]"
                              fullWidth
                            >
                              <InputLabel
                                id="demo-simple-select-helper-label"
                                fullWidth
                              >
                                Writing Style
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-helper-label"
                                id="demo-simple-select-helper"
                                className="!h-[3] !w-full !rounded-lg"
                                value={style}
                                label="Writing Style"
                                onChange={(e) => setStyle(e.target.value)}
                              >
                                <MenuItem value={"Default"}>Default</MenuItem>
                                <MenuItem value={"Academic"}>Academic</MenuItem>
                                <MenuItem value={"Analytical"}>
                                  Analytical
                                </MenuItem>
                                <MenuItem value={"Argumentative"}>
                                  Argumentative
                                </MenuItem>
                                <MenuItem value={"Conversational"}>
                                  Conversational
                                </MenuItem>
                                <MenuItem value={"Creative"}>Creative</MenuItem>
                                <MenuItem value={"Critical"}>Critical</MenuItem>
                                <MenuItem value={"Descriptive"}>
                                  Descriptive
                                </MenuItem>
                                <MenuItem value={"Epigrammatic"}>
                                  Epigrammatic
                                </MenuItem>
                                <MenuItem value={"Epistolary"}>
                                  Epistolary
                                </MenuItem>
                                <MenuItem value={"Expository"}>
                                  Expository
                                </MenuItem>
                                <MenuItem value={"Informative"}>
                                  Informative
                                </MenuItem>
                                <MenuItem value={"Instructive"}>
                                  Instructive
                                </MenuItem>
                                <MenuItem value={"Journalistic"}>
                                  Journalistic
                                </MenuItem>
                                <MenuItem value={"Metaphorical"}>
                                  Metaphorical
                                </MenuItem>
                                <MenuItem value={"Narrative"}>
                                  Narrative
                                </MenuItem>
                                <MenuItem value={"Persuasive"}>
                                  Persuasive
                                </MenuItem>
                                <MenuItem value={"Poetic"}>Poetic</MenuItem>
                                <MenuItem value={"Satirical"}>
                                  Satirical
                                </MenuItem>
                                <MenuItem value={"Technical"}>
                                  Technical
                                </MenuItem>
                              </Select>
                            </FormControl>
                            <FormControl
                              className="flex flex-col gap-1  w-[120px]"
                              fullWidth
                            >
                              <InputLabel id="demo-simple-select-helper-label">
                                Tone
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-helper-label"
                                id="demo-simple-select-helper"
                                className="!h-[3]"
                                value={tone}
                                label="Tone"
                                onChange={(e) => setTone(e.target.value)}
                              >
                                <MenuItem value={"Professional"}>
                                  Professional{" "}
                                </MenuItem>
                                <MenuItem value={"Emmotional"}>
                                  Emotional{" "}
                                </MenuItem>
                                <MenuItem value={"Encouraging"}>
                                  Encouraging{" "}
                                </MenuItem>
                                <MenuItem value={"Creative"}>
                                  Creative{" "}
                                </MenuItem>
                                <MenuItem value={"Funny"}>Funny </MenuItem>
                                <MenuItem value={"Dramatic"}>
                                  Dramatic{" "}
                                </MenuItem>
                                <MenuItem value={"Witty"}>Witty </MenuItem>
                                <MenuItem value={"Sarcastic"}>
                                  Sarcastic{" "}
                                </MenuItem>
                                <MenuItem value={"Engaging"}>
                                  Engaging{" "}
                                </MenuItem>
                              </Select>
                            </FormControl>
                            <FormControl
                              className="flex flex-col gap-1  w-[120px]"
                              fullWidth
                            >
                              <InputLabel id="demo-simple-select-helper-label">
                                Output In
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-helper-label"
                                id="demo-simple-select-helper"
                                className="!h-[3]"
                                value={language}
                                label="Output In"
                                onChange={(e) => setLanguage(e.target.value)}
                              >
                                <MenuItem value={"en"}>English </MenuItem>
                                <MenuItem value={"hindi"}>Hindi</MenuItem>
                                <MenuItem value={"kn"}>Kannada</MenuItem>
                                <MenuItem value={"fr"}>French </MenuItem>
                                <MenuItem value={"ja"}>Japanese</MenuItem>
                                <MenuItem value={"ar"}>Arabic</MenuItem>
                                <MenuItem value={"bn"}>Bangla</MenuItem>
                              </Select>
                            </FormControl>
                          </>
                        )}
                        {showsearch && (
                          <>
                            <div className="flex flex-row justify-between items-center w-full gap-3 ">
                              <input
                                className=" bg-blue-50 rounded-lg outline-none focus:outline-4 focus:outline-blue-400 border-blue-400 h-[40px] text-center w-full scrollbar-hide"
                                rows={2}
                                value={searchTerm}
                                onChange={(e) => {
                                  if (e.target.value) {
                                    setSearchTerm(e.target.value);
                                  } else {
                                    setSearchTerm(e.target.value);
                                    handleClientLoad();
                                  }
                                }}
                                // onKeyDown={(e) => e.key === "Enter" && research()}
                                placeholder="Write Text Here"
                              />
                              <button
                                className="h-[43px] flex flex-row justify-center items-center bg-blue-500 px-4 gap-2 rounded-[8px] hover:bg-blue-700 text-[16px] border-2 font-[700] leading-[19px] text-[#f9f9f9] outline-none
  focus:outline-4 focus:outline-[#31D0AA] mb-2"
                                onClick={() => {
                                  search1();
                                }}
                              >
                                <Search color="light" />
                              </button>
                            </div>
                          </>
                        )}
                        {showchatwithpdf && (
                          <>
                            <div className="flex flex-row justify-between items-center w-full gap-3 ">
                              <button
                                className="h-[43px] flex flex-row justify-center items-center bg-blue-500 px-4 gap-2 rounded-[8px] hover:bg-blue-700 text-[16px] border-2 font-[700] leading-[19px] text-[#f9f9f9] outline-none
  focus:outline-4 focus:outline-[#31D0AA] mb-2"
                                onClick={() => {
                                  setshowchatwithpdf(false);
                                  setshowsearch(true);
                                }}
                              >
                                Return
                              </button>
                            </div>
                          </>
                        )}
                      </ListItem>
                    )}
                  </>
                  <div className="w-full m-auto flex flex-col mx-1  justify-center items-center">
                    {tab === 0 && (
                      <>
                        <textarea
                          className="bg-blue-50 rounded-lg outline-none focus:outline-4 focus:outline-blue-400 border-blue-400 h-[370px] text-center pt-5 mb-1 !pl-1 w-[100%] scrollbar-hide"
                          rows={2}
                          value={SummeriseText}
                          onChange={(e) => setSummeriseText(e.target.value)}
                          placeholder="Enter Text Here"
                        />
                        <button
                          className="h-[48px] w-[100%] flex flex-row bg-blue-500 justify-center items-center  rounded-[8px] hover:bg-blue-700 text-[16px] border-2 font-[700] leading-[19px] text-[#ffffff] outline-none
  focus:outline-4 focus:outline-[#31D0AA] mt-1"
                          onClick={() => {
                            summarise(SummeriseText);
                            setSideMenu(false);
                          }}
                        >
                          SUMMARISE
                        </button>
                      </>
                    )}
                    {tab === 1 && (
                      <>
                        <textarea
                          className="bg-blue-50 rounded-lg outline-none focus:outline-4 focus:outline-blue-400 border-blue-400 h-[370px] text-center mb-1 w-full max-w-[26rem] lg:max-w-full lg:w-[100%] scrollbar-hide"
                          rows={2}
                          value={ElaborateText}
                          onChange={(e) => setElaborateText(e.target.value)}
                          placeholder="Enter Text Here"
                        />

                        <button
                          className="h-[48px] w-[100%] flex flex-row justify-center bg-blue-500 items-center px-4 gap-2 rounded-[8px] hover:bg-blue-700 text-[16px] border-2 font-[700] leading-[19px] text-[#ffffff] outline-none
  focus:outline-4 focus:outline-[#31D0AA] mt-1"
                          onClick={() => {
                            elaborate(ElaborateText);
                            // checking(ElaborateText);
                            setSideMenu(false);
                          }}
                        >
                          ELABORATE
                        </button>
                      </>
                    )}
                    {tab === 3 && (
                      <>
                        <div className="m-1 h-[420px] overflow-y-scroll scrollbar-hide w-[96%]">
                          <>
                            {!showchatwithpdf ? (
                              !showfolder ? (
                                <div>
                                  <div className="m-3 ">
                                    <input
                                      type="file"
                                      onChange={(e) => {
                                        if (e.target.files[0]) {
                                          setlocalfile(e.target.files[0]);
                                        }
                                      }}
                                    />
                                    <Button
                                      variant="contained"
                                      onClick={() => {
                                        uploadlocalfile();
                                      }}
                                    >
                                      Upload
                                    </Button>
                                  </div>
                                  <table className="min-w-full">
                                    <thead>
                                      <tr className="flex flex-row  items-center"></tr>
                                    </thead>
                                    <tbody className="">
                                      {documents.map((item, index) => (
                                        <div
                                          key={index}
                                          className="group relative"
                                        >
                                          {item.mimeType.slice(
                                            item.mimeType.length - 6,
                                            item.mimeType.length
                                          ) === "folder" ? (
                                            <div>
                                              <div
                                                className="mt-4 flex justify-between cursor-pointer  bg-white hover:bg-[#EFEFFD] p-3 rounded-lg drop-shadow-md w-[99%]"
                                                onClick={() =>
                                                  filesfromfolder(item.id)
                                                }
                                              >
                                                <div className="flex flex-row gap-8">
                                                  {show1 ? (
                                                    <FolderIcon fontSize="large" />
                                                  ) : (
                                                    <FolderIcon fontSize="large" />
                                                  )}
                                                  <p
                                                    className="mt-1 mr-5 text-base text-black "
                                                    style={{
                                                      fontFamily: "Work Sans",
                                                    }}
                                                  >
                                                    {item.title}
                                                  </p>
                                                </div>
                                              </div>
                                            </div>
                                          ) : null}
                                        </div>
                                      ))}
                                      {documents.map((item, index) => (
                                        <div
                                          key={index}
                                          className="group relative"
                                        >
                                          {item.mimeType.slice(
                                            item.mimeType.length - 6,
                                            item.mimeType.length
                                          ) === "folder" ? null : (
                                            <div
                                              className="mt-4 flex justify-between  bg-white hover:bg-[#EFEFFD] p-3 rounded-lg drop-shadow-md cursor-pointer w-[99%]"
                                              onClick={() => getfile1(item.id)}
                                            >
                                              <div className="flex flex-row gap-8">
                                                <p
                                                  className="mt-1 mr-5 text-base text-black"
                                                  style={{
                                                    fontFamily: "Work Sans",
                                                  }}
                                                >
                                                  {item.title}
                                                </p>
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              ) : (
                                <div>
                                  {show1 &&
                                    (length1 === 0 ? (
                                      <div>
                                        <button
                                          className="h-[43px] flex flex-row justify-center items-center bg-blue-500 px-4 gap-2 rounded-[8px] hover:bg-blue-700 text-[16px] border-2 font-[700] leading-[19px] text-[#f9f9f9] outline-none
  focus:outline-4 focus:outline-[#31D0AA] mb-2"
                                          onClick={() => {
                                            setshowfolder(false);
                                          }}
                                        >
                                          Return
                                        </button>
                                        <p>No data to show</p>{" "}
                                      </div>
                                    ) : (
                                      <>
                                        <button
                                          className="h-[43px] flex flex-row justify-center items-center bg-blue-500 px-4 gap-2 rounded-[8px] hover:bg-blue-700 text-[16px] border-2 font-[700] leading-[19px] text-[#f9f9f9] outline-none
  focus:outline-4 focus:outline-[#31D0AA] mb-2"
                                          onClick={() => {
                                            setshowfolder(false);
                                          }}
                                        >
                                          Return
                                        </button>
                                        {foldersdata.map((item, index) => (
                                          <div
                                            key={index}
                                            className="group relative"
                                          >
                                            {
                                              <div
                                                className="mt-4 ml-16 flex bg-white hover:bg-[#EFEFFD] p-3 rounded-lg drop-shadow-md cursor-pointer w-[99%]"
                                                onClick={() => {
                                                  uploadgd(
                                                    item.alternateLink,
                                                    item.title,
                                                    user.id
                                                  );
                                                  setshowchatwithpdf(true);
                                                  setshowsearch(false);
                                                }}
                                              >
                                                <div className="flex flex-row gap-8">
                                                  <p
                                                    className="mt-1 mr-5 text-base text-black"
                                                    style={{
                                                      fontFamily: "Work Sans",
                                                    }}
                                                  >
                                                    {item.title}
                                                  </p>
                                                </div>
                                              </div>
                                            }
                                          </div>
                                        ))}
                                      </>
                                    ))}
                                </div>
                              )
                            ) : (
                              <div>
                                <div
                                  id="messages"
                                  style={{ fontFamily: "Work Sans" }}
                                  className="flex flex-col p-3  overflow-y-scroll  scrollbar-thumb-rounded scrollbar-track-blue-lighter scrollbar-w-2 scrolling-touch messages scrollbar-hide"
                                >
                                  {displayMessages &&
                                    displayMessages.map((msg, i) => (
                                      <Fade bottom>
                                        <div
                                          className="chat-message py-2"
                                          key={i}
                                        >
                                          <div
                                            className={`flex items-end ${
                                              msg[1] === "sent" && "justify-end"
                                            }`}
                                          >
                                            <div className="flex flex-col space-y-2 text-md max-w-lg mx-2 order-2 items-end">
                                              <div>
                                                <span
                                                  className={`px-4 py-2 rounded-lg inline-block rounded-bl-none ${
                                                    msg[1] === "sent"
                                                      ? "bg-[#428CFB] text-white"
                                                      : "bg-gray-300 text-gray-600"
                                                  }`}
                                                >
                                                  {msg[0]}
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </Fade>
                                    ))}
                                  <div id="bottomRef" ref={bottomRef} />
                                </div>
                                <div className="px-4 mb-2">
                                  <div className="relative pt-4 flex justify-between items-center w-full">
                                    <input
                                      type="text"
                                      placeholder="Write your message!"
                                      value={msg}
                                      rows={1}
                                      onChange={(e) => setMsg(e.target.value)}
                                      onKeyDown={(e) => {
                                        if (e.shiftKey && e.code === 13)
                                          setMsg(msg + "\n");
                                        else if (
                                          e.key === "Enter" &&
                                          !input &&
                                          !e.shiftKey
                                        )
                                          getChat();
                                      }}
                                      className="lg:w-[80%] focus:outline-none focus:placeholder-gray-400 text-gray-600 placeholder-gray-600 pl-2 bg-gray-200 rounded-md py-3 scrollbar-hide w-full mr-2"
                                    />
                                    <div className=" right-0 items-center inset-y-0 sm:flex">
                                      <button
                                        disabled={input}
                                        type="button"
                                        className="inline-flex items-center justify-center rounded-lg px-4 py-3 transition duration-500 ease-in-out text-white bg-[#428CFB] hover:bg-[#428CFB] focus:outline-none"
                                        onClick={() => getChat()}
                                      >
                                        <span className="font-bold">Send</span>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 20 20"
                                          fill="currentColor"
                                          className="h-6 w-6 ml-2 transform rotate-90"
                                        >
                                          <path d="M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z"></path>
                                        </svg>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </>
                        </div>
                      </>
                    )}
                    {tab === 2 && (
                      <>
                        <div className="flex flex-row justify-between items-center gap-3 w-full">
                          <>
                            {re2 === "true" ? (
                              <Tooltip
                                open={re2 === "true"}
                                placement="bottom"
                                arrow
                                title={
                                  <div className="rounded-lg">
                                    <p
                                      className="text-white text-base max-[750px]:text-xs"
                                      style={{ fontFamily: "Work Sans" }}
                                    >
                                      Let's “Research”! Type the Cornell method
                                      of note-taking. You can type in any
                                      question or topic you’d like to learn more
                                      about
                                    </p>
                                  </div>
                                }
                                componentsProps={{
                                  tooltip: {
                                    sx: {
                                      bgcolor: "#0E0E2C",
                                      "& .MuiTooltip-arrow": {
                                        color: "#0E0E2C",
                                      },
                                    },
                                  },
                                }}
                              >
                                <input
                                  className="pulse flex justify-between items-center bg-blue-50 rounded-lg outline-none focus:outline-4 focus:outline-blue-400 border-blue-400 h-[40px] text-center w-full scrollbar-hide"
                                  rows={2}
                                  value={researchText}
                                  onChange={(e) => {
                                    setResearchText(e.target.value);
                                    setre2("false");
                                    setai1("true");
                                  }}
                                  onKeyDown={(e) =>
                                    e.key === "Enter" && research()
                                  }
                                  placeholder="Write Text Here"
                                />
                              </Tooltip>
                            ) : (
                              <div className="bg-blue-50 flex justify-between items-center rounded-lg outline-none outline-2 outline-blue-400 text-center w-[90%] scrollbar-hide">
                                <input
                                  className="bg-transparent w-full text-center outline-none"
                                  rows={2}
                                  value={researchText}
                                  onChange={(e) =>
                                    setResearchText(e.target.value)
                                  }
                                  onKeyDown={(e) =>
                                    e.key === "Enter" && research()
                                  }
                                  placeholder="Write Text Here"
                                />
                                <div className="flex items-center justify-center">
                                  <span className="hidden lg:block">
                                    {academic ? "Academic" : "Web Search"}{" "}
                                  </span>
                                  <Switch
                                    checked={academic}
                                    onChange={() => setAcademic(!academic)}
                                  />
                                </div>
                              </div>
                            )}
                          </>
                          <button
                            className="h-[42px] flex flex-row justify-center items-center bg-blue-500 px-4 gap-2 rounded-[8px] hover:bg-blue-700 text-[16px] border-2 font-[700] leading-[19px] text-[#f9f9f9] outline-none focus:outline-4 focus:outline-[#31D0AA]"
                            onClick={() => {
                              research();
                            }}
                          >
                            <TravelExplore color="light" />
                          </button>
                        </div>
                        {!showLoadMore && loading && <Loading />}
                        {researchResponse?.length >= 1 &&
                          researchResponse.map(
                            (card) =>
                              card && (
                                <div
                                  className="m-auto w-[90%]"
                                  key={card.paperId}
                                >
                                  <ResearchCard
                                    handleCitations={handleCitations}
                                    saveText={saveText}
                                    getIndex={getIndex}
                                    caption={caption}
                                    headCaption={headCaption}
                                    titleObject={titleObject}
                                    notes={notes}
                                    isBookmarked={isBookmarked}
                                    setLoading={setLoading}
                                    data={card}
                                    setSideMenu={setSideMenu}
                                    editor={ref}
                                    onViewInNewTab={() => handleView(card.url)}
                                    onsetBookmark={() =>
                                      setBookmark(
                                        user.id,
                                        card.title,
                                        card.paperId,
                                        card.url
                                      )
                                    }
                                  />
                                </div>
                              )
                          )}
                        {!academic && <WIkiCard data={researchResponse} />}
                        {loading && showLoadMore && <Loading />}
                        {academic && showLoadMore && (
                          <button
                            className="bg-blue-500 px-4 py-2 text-white rounded mt-4"
                            onClick={() => research(true)}
                          >
                            Load More
                          </button>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
          <>
            {!showprogressbar ? (
              <div className="mb-3 mt-2 m-auto  inset-x-0 bottom-0 w-[94%]">
                <div className="flex justify-between mb-1 w-[100%]">
                  <span
                    className="text-base font-medium text-blue-500 cursor-pointer"
                    onClick={() => {
                      let path = `/dashboard/subscriptions`;
                      navigate(path);
                    }}
                  >
                    Upgrade &rarr;
                  </span>
                  <span className="text-sm font-medium text-blue-500 ">
                    {user.credits_left}
                  </span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2.5">
                  <div
                    className="bg-blue-500 h-2.5 rounded-full"
                    style={{ width: "50%" }}
                  ></div>
                </div>
              </div>
            ) : null}
          </>
        </Drawer>
      </div>
      <div
        id="printable"
        className="w-[100%] !h-[100%] overflow-y-scroll scrollbar-hide"
      >
        <div id="editorjs">
          <div
            className={`w-full flex justify-center ${loading ? "" : "hidden"}`}
          >
            <>{loading ? <Loading /> : null}</>
          </div>
        </div>
      </div>
      <div
        id="citations-panel"
        class="references-panel_citationsContainer__gpkk1"
      >
        <div class="flex items-center justify-between">
          <div class="flex items-center space-x-2">
            <h3 class="font-bold leading-7 text-xl">Bibliography</h3>
          </div>
        </div>
        <div>
          <ol class="references-panel_citations__B8Mj_">
            {citations.map((citation, index) => (
              <li
                key={index} // Add a unique key for each citation
                data-cy="reference-cite"
                className="select-none brightness-100 contrast-100 grayscale-0 hue-rotate-0 invert-0 saturate-100 sepia-0 drop-shadow-none"
              >
                {citation} {/* Assuming citation is a string */}
              </li>
            ))}
          </ol>
        </div>
      </div>

      <Dialog
        open={ft === "true"}
        keepMounted
        onClose={() => {
          setft("false");
        }}
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          style: {
            backgroundColor: "black",
            borderRadius: 10,
          },
        }}
      >
        <DialogContent className=" rounded-lg">
          <p
            className="text-white text-base max-[750px]:text-xs"
            style={{ fontFamily: "Work Sans" }}
          >
            Congrats! You've reached a cool milestone by creating your content!
            🤲
          </p>
          {/* <ArrowBackIcon sx= {
                      {
                       color: 'white',
                     }
                   } className="ml-16 cursor-pointer" fontSize="large" onClick={()=>{
                    setai1("true")
                    setSideMenu(true)
                    setft("false")
          }}/> */}
          <ArrowForwardIcon
            sx={{
              color: "white",
            }}
            className="ml-2 cursor-pointer"
            fontSize="large"
            onClick={() => {
              setparad("true");
              setft("false");
            }}
          />
        </DialogContent>
      </Dialog>
      {/* Inline Menu */}
      {inlineMenu && (
        <div className="fixed inset-0 flex justify-center items-center z-50 w-full m-auto ">
          <InlineMenu
            handleInlineResult={handleInlineResult}
            setShowInlineResult={() => setShowInlineResult([])}
            handleInsert={handleInsert}
            handleTryAgain={handleTryAgain}
            handleDiscard={handleDiscard}
            setAiText={setAiText}
            showInlineResult={showInlineResult}
            handleInlineContextMenu={handleInlineContextMenu}
            handleInlineContextSubMenuSecondary={
              handleInlineContextSubMenuSecondary
            }
            handleInlineContextSubMenuPrimaryOption={
              handleInlineContextSubMenuPrimaryOption
            }
            saveText={saveText}
            getIndex={getIndex}
            caption={caption}
            headCaption={headCaption}
            titleObject={titleObject}
            notes={notes}
            isBookmarked={isBookmarked}
            setInlineMenu={setInlineMenu}
            generateInput={generateInput}
            setPropGenerateInput={setPropGenerateInput}
            elaborateInlineCustom={elaborateInlineCustom}
            loading={loading}
            setLoading={setLoading}
            onSetPropSources={() => onSetPropSources([])}
            setSideMenu={setSideMenu}
            ref={ref}
            academic={academic}
            researchText={researchText}
            setOffset={setOffset}
            showLoadMore={showLoadMore}
            setResearchResponse={setResearchResponse}
            setShowLoadMore={setShowLoadMore}
          />
        </div>
      )}
      {citeMenu && (
        <div className="fixed inset-0 flex justify-center items-center z-50 overflow-auto max-h-[50vh]">
          <CiteMenu
            user={user}
            saveText={saveText}
            getIndex={getIndex}
            caption={caption}
            headCaption={headCaption}
            titleObject={titleObject}
            notes={notes}
            isBookmarked={isBookmarked}
            setLoading={setLoading}
            setSideMenu={setSideMenu}
            editor={ref}
            onsetBookmark={setBookmark}
            handleView={handleView}
            showLoadMore={showLoadMore}
            loading={loading}
            academin={academic}
            research={research}
            generateInput={generateInput}
            setCiteMenu={setCiteMenu}
          />
        </div>
      )}

      <Dialog
        open={parad === "true"}
        keepMounted
        onClose={() => {
          setparad("false");
        }}
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          style: {
            backgroundColor: "black",
            borderRadius: 10,
          },
        }}
      >
        <DialogContent className=" rounded-lg">
          <p
            className="text-white text-base max-[750px]:text-xs"
            style={{ fontFamily: "Work Sans" }}
          >
            Do you wish to continue the tutorial? Explore more to see how Gyani
            could assist you in becoming a better writer! 😤
          </p>
          {/* <ArrowBackIcon sx= {
                      {
                       color: 'white',
                     }
                   } className="ml-16 cursor-pointer" fontSize="large" onClick={()=>{
                    setparad("false")
                    setft("true")
          }}/> */}
          <ArrowForwardIcon
            sx={{
              color: "white",
            }}
            className="ml-2 cursor-pointer"
            fontSize="large"
            onClick={() => {
              setparad("false");
              setgs("true");
            }}
          />
        </DialogContent>
      </Dialog>

      <Dialog
        open={generateDialog1}
        // TransitionComponent={Transition}
        keepMounted
        onClose={() => setGenerateDialog1(!generateDialog1)}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>
          {"Research some text data by entering the Text."}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <input
              type="text"
              placeholder="Write your Text!"
              value={researchText}
              rows={1}
              onKeyUp={(e) =>
                e.key === "Enter" && research() && setGenerateDialog1(false)
              }
              onChange={(e) => setResearchText(e.target.value)}
              className="lg:w-full focus:outline-none focus:placeholder-gray-400 text-gray-600 placeholder-gray-600 pl-12 bg-gray-200 rounded-md py-3 scrollbar-hide"
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={() => {
              research(researchText);
              setGenerateDialog1(false);
            }}
          >
            Search
          </Button>
          <Button onClick={() => setGenerateDialog1(!generateDialog1)}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={() => setOpen(false)}
        message={snackbarText}
        anchorOrigin={{ vertical, horizontal }}
      >
        {snackbarText === "Title must be of more than 3 characters!" ||
        snackbarText === "Category field is empty!" ? (
          <Alert
            severity={"error"}
            sx={{
              backgroundColor: "#dc2f02",
            }}
          >
            {snackbarText}
          </Alert>
        ) : (
          <Alert
            severity={"success"}
            sx={{
              backgroundColor: "lightGreen",
            }}
          >
            {snackbarText}
          </Alert>
        )}
      </Snackbar>
      <div
        className={`${LeftDrawerOpen ? "ml-36" : ""}`}
        style={{
          position: "fixed",
          bottom: 0,
          left: 150,
          right: 65,
          zIndex: 1000,
        }}
      >
        {!mobileDrawer && (
          <div
            className={`mb-2 flex flex-row bg-white outline-offset-1 outline-gray-600 shadow-md h-[60px]`}
          >
            <textarea
              id="message1"
              rows="1"
              style={{
                height: "40px",
                resize: "none",
              }}
              className=" !h-[60px] !bg-gray-200 !mr-2 block !p-2.5 !w-[70rem] !text-sm !text-gray-900 !rounded-lg border border-blue-500 focus:ring-blue-500 focus:border-blue-500"
              placeholder="Ask Gyani AI anything..."
              value={aiText}
              onKeyUp={(e) =>
                e.key === "Enter" && elaborateCustom(generateInput, aiText)
              }
              onChange={(e) => setAiText(e.target.value)}
              inputlabelprops={{
                style: {
                  fontSize: "10px",
                  fontWeight: 600,
                },
              }}
            ></textarea>

            <Button
              className={`${
                LeftDrawerOpen ? "!text-sm !p-0" : ""
              } !normal-case !m-auto !mr-2 w-24 !p-0`}
              style={{
                height: 30,
              }}
              variant="contained"
              color="primary"
              onClick={() => {
                elaborateCustom(generateInput, aiText);
              }}
            >
              Ask AI
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
